/*! Ardor Real Estate Designer Kit v1 (Oct 19, 2026) - Ardor Printing, ardorprinting.com
 * Copy of assets/ardor-designer-kit.js (the banner designer kit, Oct 18) for the real estate sign designer:
 * Templates (sign and rider layouts per piece), Add heading / subheading / body text, Text suggestions, Quick text,
 * Background, QR code, brokerage logo spot, agent photo spot, sample-text warning.
 * Talks to the designer only through window.ArdorRealestateLayers.kit and window.ArdorRealestateAPI (via kit.api()).
 * Heavy parts load on first use from window.ArdorKitAssets: bg (ArdorBG), data (ArdorTPLData from
 * assets/ardor-realestate-tpl-data.js), tpl (ArdorTPL), qr (ArdorQR). Every item is an ordinary layer that the designer
 * flattens into the print file and paints on the 3D view and the proof, exactly like text and clipart.
 * Faces: front, back (the sign), rider-front, rider-back (the rider). kit.banner() is the CURRENT piece.
 * Template details are kept in localStorage key ardorKitInfoRE: { agent, brokerage, phone, web }.
 * Template tokens: {business} = agent name, {tagline} = brokerage (this file fills AGENT NAME / YOUR BROKERAGE when empty).
 */
(function () {
  'use strict';
  if (window.ArdorRealestateKit) return;

  var K = null, API = null, fabric = null, fc = null, booted = false, uiReady = false;
  var ASSETS = window.ArdorKitAssets || {};
  var loaded = {}, loading = {};
  var st = { info: { agent: '', brokerage: '', phone: '', web: '' }, byFace: {}, tpl: null, tplFace: null, tplVar: '', tplDirty: false, suggCat: '', tplCat: '', bgCat: 'Solid', thumbs: {}, thumbKey: '', qrEdit: null, rebuilding: false };
  var FONT_PRE = ['Anton', 'Jost', 'Bebas Neue', 'Unbounded', 'Rubik Mono One', 'Pacifico', 'Monoton', 'Satisfy', 'Bree Serif', 'Bangers', 'Quicksand', 'Permanent Marker', 'Black Ops One', 'Righteous', 'Lobster', 'Italiana'];

  // ---------- helpers ----------
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function phone() { try { return window.matchMedia('(max-width: 900px)').matches; } catch (e) { return window.innerWidth <= 900; } }
  function toast(m, ms, act) { try { K.toast(m, ms || 4000, act); } catch (e) {} }
  function track(k) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ardor_kit_' + k }); } catch (e) {} }
  function lsGet(k) { try { return JSON.parse(window.localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function failed(e) { try { console.warn('[ardor kit]', e); } catch (x) {} toast('That tool could not load. Please refresh the page and try again.', 6000); }

  // ---------- real estate (Oct 19 2026): pieces, faces, template details ----------
  var INFO_KEY = 'ardorKitInfoRE';
  var FACES = ['front', 'back', 'rider-front', 'rider-back'];
  // the piece of the face being edited (the face id decides; the designer's piece() while it has no face id)
  function pieceOf() {
    var f = ''; try { f = String((K && K.face()) || ''); } catch (e) {}
    if (/^rider/.test(f)) return 'rider';
    if (f === 'front' || f === 'back') return 'sign';
    try { if (K && K.piece) { var p = K.piece(); if (p) return p === 'rider' ? 'rider' : 'sign'; } } catch (e) {}
    try { var b = K.banner(); if (b && b.Wi / b.Hi >= 3.2) return 'rider'; } catch (e) {}
    return 'sign';
  }
  // false while the designer is between pieces (its piece() already switched, the layers face not yet, or the reverse)
  function settled() {
    var f = '', p = ''; try { f = String(K.face() || ''); p = K.piece ? String(K.piece() || '') : ''; } catch (e) { return false; }
    return !p || !f || (p === 'rider') === /^rider/.test(f);
  }
  function isRiderTpl(it) { return !!(it && it.tags && it.tags.indexOf('rider') >= 0); }
  function forPiece(it) { return isRiderTpl(it) === (pieceOf() === 'rider'); }
  // what ArdorTPL substitutes: {business} = agent name, {tagline} = brokerage, {phone}, {web}
  function tinfo() { var i = st.info || {}; return { business: i.agent || 'AGENT NAME', tagline: i.brokerage || 'YOUR BROKERAGE', phone: i.phone || '', web: i.web || '' }; }
  // the area templates are laid out in: the safe area, minus a band along an edge where holes must stay clear
  // (API.guides().keep, e.g. the two hanging holes of a post sign), so template text never runs through a hole
  function r2(v) { return Math.round(v * 100) / 100; }
  function pageOfFace(f) { try { var pg = API && API.pageOf ? API.pageOf(f) : null; if (pg && pg.Wi > 0 && pg.Hi > 0) return pg; } catch (e) {} return null; }
  // the safe rect of any face (the builder's safeBox(face)); 0.5 in inside the page without it
  function safeFor(face, pg) {
    try { if (API && API.safeBox) { var s = API.safeBox(face); if (s && s.w > 0 && s.h > 0) return { x: s.x, y: s.y, w: s.w, h: s.h }; } } catch (e) {}
    return { x: 0.5, y: 0.5, w: Math.max(1, pg.Wi - 1), h: Math.max(1, pg.Hi - 1) };
  }
  // keep-clear boxes around hanging holes of any face: from the sign data (window.ArdorRealestateSpecs) for the current
  // sign key and rider size, mirrored on a back face; else API.guides() for the face on screen
  function keepFor(face, pg) {
    var out = [];
    try {
      var S = window.ArdorRealestateSpecs, key = API && API.signKey ? API.signKey() : null, e = S && S.keys && key ? S.keys[key] : null;
      if (e) {
        var src = /^rider/.test(face) ? ((e.riders || {})[r2(pg.Wi) + 'x' + r2(pg.Hi)] || {}).keep : (e.sign || {}).keep;
        (src || []).forEach(function (k) {
          var r = (k && (k.r || k.rect)) || k; if (!r || r.length !== 4) return;
          out.push(/back$/.test(face) ? [pg.Wi - r[0] - r[2], r[1], r[2], r[3]] : [r[0], r[1], r[2], r[3]]);
        });
        return out;
      }
    } catch (x) {}
    try { if (face === curFace() && API && API.guides) { var g = API.guides(); ((g && g.keep) || []).forEach(function (k) { k = (k && (k.r || k.rect)) || k; if (k && k.length === 4) out.push(k); }); } } catch (x) {}
    return out;
  }
  // the area templates are laid out in: the safe area, minus a band along an edge where holes must stay clear
  // (e.g. the two hanging holes of a post sign), so template text never runs through a hole
  function tplSafe(z, face) {
    face = face || curFace();
    var s = { x: z.safe.x, y: z.safe.y, w: z.safe.w, h: z.safe.h };
    keepFor(face, { Wi: z.Wi, Hi: z.Hi }).forEach(function (k) {
      var x0 = k[0], y0 = k[1], x1 = k[0] + k[2], y1 = k[1] + k[3], d;
      if (x1 <= s.x || x0 >= s.x + s.w || y1 <= s.y || y0 >= s.y + s.h) return;
      if (y1 <= z.Hi * 0.3) { d = y1 - s.y; s.y += d; s.h -= d; }
      else if (y0 >= z.Hi * 0.7) { s.h = y0 - s.y; }
      else if (x1 <= z.Wi * 0.3) { d = x1 - s.x; s.x += d; s.w -= d; }
      else if (x0 >= z.Wi * 0.7) { s.w = x0 - s.x; }
    });
    return s.w >= z.safe.w * 0.6 && s.h >= z.safe.h * 0.6 ? s : z.safe;
  }
  // what a template was laid out for: page size + layout area. Kept on the face's background layer (ablBg.fit and
  // ablBg.tpl; ablBg is saved with undo / redo), so a face whose page or area changed is re-arranged, on screen or not
  function areaKey(W, H, a) { return r2(W) + 'x' + r2(H) + '|' + [a.x, a.y, a.w, a.h].map(r2).join(','); }
  function fitSpec(spec, id, key) { var o = {}, k; spec = spec || { t: 'solid', c: '#FFFFFF' }; for (k in spec) { if (Object.prototype.hasOwnProperty.call(spec, k)) o[k] = spec[k]; } o.fit = key; o.tpl = id; return o; }
  function keepFit(spec, prev) { if (!prev || !prev.fit || !spec) return spec; return fitSpec(spec, prev.tpl, prev.fit); }

  function load(name) {
    var glob = { bg: 'ArdorBG', data: 'ArdorTPLData', tpl: 'ArdorTPL', qr: 'ArdorQR' }[name];
    if (glob && window[glob]) return Promise.resolve(window[glob]);
    if (loading[name]) return loading[name];
    loading[name] = new Promise(function (res, rej) {
      var src = ASSETS[name];
      if (!src) { rej(new Error('no asset url for ' + name)); return; }
      var s = document.createElement('script'); s.src = src; s.async = true;
      s.onload = function () { loaded[name] = true; if (window[glob]) res(window[glob]); else rej(new Error(name)); };
      s.onerror = function () { loading[name] = null; rej(new Error('load ' + name)); };
      document.head.appendChild(s);
    });
    return loading[name];
  }
  function loadTpl() { return load('data').then(function () { return load('tpl'); }); }

  function cfgSize() { var b = K.banner(); return { b: b, Wi: b.Wi, Hi: b.Hi, safe: API && API.safeBox ? safeFor(curFace(), b) : K.safeArea(b.c, b.Wi, b.Hi) }; }
  function canvas() { fc = K.canvas(); return fc; }
  function curFace() { return K.face(); }
  function objs() { return canvas() ? fc.getObjects() : []; }
  function bgObj() { var o = objs().filter(function (x) { return x.ablKind === 'bg'; }); return o[0] || null; }
  function faceArt(f) { try { return API.getArt(f || curFace()); } catch (e) { return null; } }
  function fontsReady(list) {
    return K.loadFonts().then(function () { return Promise.all(list.map(function (f) { return K.fontReady(f); })); });
  }

  // ---------- custom Fabric classes ----------
  function registerClasses() {
    if (fabric.ArdorBg) return;
    fabric.ArdorBg = fabric.util.createClass(fabric.Object, {
      type: 'ardorBg',
      initialize: function (o) {
        o = o || {};
        this.callSuper('initialize', o);
        this.set({ originX: 'left', originY: 'top', strokeWidth: 0, stroke: null, selectable: false, evented: false, hasControls: false, hasBorders: false, objectCaching: false, ablKind: 'bg' });
        this.ablBg = o.ablBg || { t: 'solid', c: '#FFFFFF' };
      },
      _render: function (ctx) {
        var w = this.width, h = this.height;
        if (window.ArdorBG) { try { window.ArdorBG.draw(ctx, -w / 2, -h / 2, w, h, this.ablBg); return; } catch (e) {} }
        ctx.fillStyle = (this.ablBg && this.ablBg.c) || '#FFFFFF'; ctx.fillRect(-w / 2, -h / 2, w, h);
      }
    });
    fabric.ArdorBg.fromObject = function (o, cb) { var x = new fabric.ArdorBg(o); if (cb) cb(x); return x; };
  }

  // ---------- boot ----------
  function boot() {
    if (booted) return;
    var L = window.ArdorRealestateLayers;
    if (!L || !L.kit) return;
    K = L.kit; API = K.api(); booted = true;
    if (K.ui() && K.ui().drawer) buildUi();
    else document.addEventListener('ardor:layers-kit-ui', function () { buildUi(); });
    setInterval(watchTick, 450);
    // re-arrange right after the designer redraws (size, product or rider picked), not only on the 450 ms watch
    try { if (API.root && API.root.addEventListener) API.root.addEventListener('ardor:realestate-view', function () { clearTimeout(st.fitT); st.fitT = setTimeout(fitAll, 30); }); } catch (e) {}
    // load Fabric + the background module early but idle, so undo / restore of backgrounds always works
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    idle(function () { withFabric().catch(function () {}); });
  }
  function withFabric() {
    return K.ready().then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return load('bg');
    });
  }
  var hooked = false;
  function hookCanvas() {
    if (hooked || !fc) return; hooked = true;
    var sb = fc.sendBackwards, stb = fc.sendToBack;
    fc.sendBackwards = function (o) { var r = sb.apply(fc, arguments); bgBottom(); return r; };
    fc.sendToBack = function (o) { var r = stb.apply(fc, arguments); if (o && o.ablKind !== 'bg') bgBottom(); return r; };
    fc.on('object:added', function () { bgBottom(); if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:removed', function () { if (!st.rebuilding) qtRefreshSoon(); });
    fc.on('object:modified', function (e) { if (!st.rebuilding && e && e.target && e.target.ablTpl) st.tplDirty = true; });
    fc.on('text:changed', function (e) { if (e && e.target && e.target.ablTpl) st.tplDirty = true; qtRefreshSoon(true); });
    fc.on('selection:created', selSync); fc.on('selection:updated', selSync); fc.on('selection:cleared', selSync);
    fc.on('after:render', drawGuides);
    // Oct 20 2026 (refix): clicks go through the see-through middle of a photo ring / frame (see ringClicks)
    fc.on('object:added', function (e) { ringClicks(e && e.target); });
    fc.getObjects().forEach(ringClicks);
  }
  // Oct 20 2026 (refix): the ring or frame a template draws over its agent photo spot (For Sale Agent Photo, Open House
  // side and agent, Sold agent, Luxury marble) is the layer above the spot, so it caught every click on the spot or on
  // the photo and the Upload / Replace photo panel never showed. Fabric now picks it only where it is painted
  // (perPixelTargetFind): a click in its see-through middle goes to the spot or photo under it, a click on the ring
  // itself still picks the ring. Only hit testing changes: canvas, 3D, proof and print look the same. Set on every add
  // (template, undo, redo, face switch) and on the 450 ms watch, because saved layers do not keep it.
  function ringClicks(o) { if (o && o.ablTpl && o.ablKind === 'clipart' && /^Photo (ring|frame)$/i.test(o.ablLabel || '') && !o.perPixelTargetFind) o.perPixelTargetFind = true; }
  // with a full background layer the designer's own guides (safe line, hems, grommets) sit under it: draw them on top
  // real estate: hidden zones (frame lip, clips), holes and the dashed safe line of the current piece, from API.guides()
  function drawGuides() {
    if (!fc || !bgObj()) return;
    var z; try { z = cfgSize(); } catch (e) { return; }
    var g = null; try { g = API.guides ? API.guides() : null; } catch (e) { g = null; }
    var Wi = z.Wi, Hi = z.Hi, v = fc.viewportTransform, rs = fc.getRetinaScaling ? fc.getRetinaScaling() : 1, ctx = fc.getContext();
    if (!ctx || !v || !(Wi > 0) || !(Hi > 0)) return;
    var lw = Math.max(Wi, Hi) / 600, s = (g && g.safe) || z.safe;
    ctx.save();
    ctx.setTransform(v[0] * rs, 0, 0, v[3] * rs, v[4] * rs, v[5] * rs);
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.clip();
    ctx.fillStyle = 'rgba(12,13,13,0.30)';
    ((g && g.hidden) || []).forEach(function (r) { r = (r && r.rect) || r; if (r && r.length === 4) ctx.fillRect(r[0], r[1], r[2], r[3]); });
    if (s && s.w > 0 && s.h > 0) {
      ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(255,255,255,0.75)';
      ctx.strokeRect(s.x, s.y, s.w, s.h);
      ctx.lineDashOffset = lw * 5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
      ctx.strokeRect(s.x, s.y, s.w, s.h);
      ctx.setLineDash([]);
    }
    ((g && g.holes) || []).forEach(function (h) {
      if (!h || h.length < 2) return;
      var r = Math.max(0.1, (h[2] || 0.25) / 2);
      ctx.beginPath(); ctx.arc(h[0], h[1], r + 0.12, 0, Math.PI * 2); ctx.fillStyle = '#B9BCBF'; ctx.fill();
      ctx.beginPath(); ctx.arc(h[0], h[1], r, 0, Math.PI * 2); ctx.fillStyle = '#FFFFFF'; ctx.fill();
    });
    ctx.restore();
  }
  function bgBottom() { var b = bgObj(); if (b && fc.getObjects().indexOf(b) > 0) { fc.moveTo(b, 0); fc.requestRenderAll(); } }

  // ---------- UI ----------
  var IC = {
    tpl: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    bg: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="m3 16 5-5 4 4 3-3 6 6"/><circle cx="16" cy="9" r="1.6"/></svg>',
    qr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="20" height="20"><path d="M6 6l12 12M18 6 6 18"/></svg>'
  };
  var ui = {};
  function railBtn(name, icon, label) {
    var b = el('button', 'abx-tool abl-tool adk-tool', '<span class="abl-tool-ic" aria-hidden="true">' + icon + '</span><span>' + label + '</span>');
    b.type = 'button'; b.setAttribute('data-abl-tool', name); b.setAttribute('aria-expanded', 'false');
    return b;
  }
  function panel(name, title, body) {
    var p = el('div', 'abl-drawer__panel adk-panel', '<div class="abl-drawer__head"><h2>' + title + '</h2><button type="button" class="abl-x" data-adk-close aria-label="Close">' + IC.x + '</button></div><div class="abl-drawer__body adk-body">' + body + '</div>');
    p.setAttribute('data-abl-panel', name); p.hidden = true;
    $('[data-adk-close]', p).addEventListener('click', function () { K.closeDrawer(); });
    ui.drawer.appendChild(p);
    return p;
  }
  function buildUi() {
    if (uiReady) return;
    var u = K.ui(); if (!u || !u.drawer) return;
    uiReady = true; ui.drawer = u.drawer;
    var rail = document.querySelector('.abx-rail');
    var textBtn = rail && $('[data-abl-tool="text"]', rail), clipBtn = rail && $('[data-abl-tool="clipart"]', rail);
    ui.tTpl = railBtn('templates', IC.tpl, 'Templates');
    ui.tBg = railBtn('background', IC.bg, 'Background');
    ui.tQr = railBtn('qr', IC.qr, 'QR code');
    if (rail && textBtn) {
      rail.insertBefore(ui.tTpl, textBtn);
      var after = clipBtn ? clipBtn.nextSibling : textBtn.nextSibling;
      rail.insertBefore(ui.tBg, after); rail.insertBefore(ui.tQr, ui.tBg.nextSibling);
    } else {
      var host = (textBtn && textBtn.parentNode) || document.querySelector('.abl-minirail');
      if (host) { host.insertBefore(ui.tTpl, host.firstChild); host.appendChild(ui.tBg); host.appendChild(ui.tQr); }
    }
    // the print-template download button keeps working; its label now says what it is
    $$('.abx-rail .abx-tool').forEach(function (b) { var s = b.querySelector('span:last-child'); if (s && /^\s*Template\s*$/.test(s.textContent) && !b.classList.contains('adk-tool')) { s.textContent = 'Print template'; b.title = 'Download a print-ready template for this size (for your own designer)'; } });
    [ui.tTpl, ui.tBg, ui.tQr].forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-abl-tool');
        setTimeout(function () { if (n === 'templates') openTemplates(); if (n === 'background') openBackground(); if (n === 'qr') openQr(); }, 0);
      });
    });
    buildTextExtras();
    buildTemplatesPanel();
    buildBgPanel();
    buildQrPanel();
    buildPropsExtras();
    var saved = lsGet(INFO_KEY); if (saved) st.info = { agent: saved.agent || '', brokerage: saved.brokerage || '', phone: saved.phone || '', web: saved.web || '' };
    syncInfoFields();
    // the empty canvas card: offer templates too
    var card = document.querySelector('.abx-empty__card');
    if (card && !card.querySelector('.adk-empty-tpl')) {
      var a = el('button', 'adk-empty-tpl', IC.tpl + ' <span>Start from a <u>ready-made template</u></span>'); a.type = 'button';
      a.addEventListener('click', function () { ui.tTpl.click(); });
      card.appendChild(a);
    }
    if (/[#&?]kit=templates/.test(location.href)) setTimeout(function () { ui.tTpl.click(); }, 600);
    // ?tpl=<template id> (works with ?preset=w:8,h:4): open the designer with that template already on the banner
    var tm = /[#&?]tpl=([a-z0-9-]+)/i.exec(location.href);
    if (tm) setTimeout(function () { loadTpl().then(function () { var it = window.ArdorTPL.get(tm[1]); if (it && forPiece(it) && !designOnFace()) applyTemplate(it, { reason: 'link' }); }).catch(function () {}); }, /[?&]preset=/.test(location.search) ? 1800 : 700);
  }

  // ---------- Text: presets, suggestions, quick text ----------
  function buildTextExtras() {
    var tp = $('[data-abl-panel="text"]', ui.drawer); if (!tp) return;
    var body = $('.abl-drawer__body', tp);
    var fontsWrap = el('div', 'adk-tabpane', ''); fontsWrap.setAttribute('data-adk-pane', 'fonts');
    while (body.firstChild) fontsWrap.appendChild(body.firstChild);
    var top = el('div', 'adk-text-top',
      '<div class="adk-presets">' +
        '<button type="button" class="adk-preset adk-preset--h" data-adk-preset="h"><b>Add a heading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--s" data-adk-preset="s"><b>Add a subheading</b></button>' +
        '<button type="button" class="adk-preset adk-preset--b" data-adk-preset="b"><b>Add body text</b></button>' +
      '</div>' +
      '<div class="adk-tabs" role="tablist"><button type="button" role="tab" data-adk-tab="sugg" aria-selected="true">Suggestions</button><button type="button" role="tab" data-adk-tab="fonts" aria-selected="false">Fonts</button><button type="button" role="tab" data-adk-tab="quick" aria-selected="false">Quick text</button></div>');
    body.appendChild(top);
    var sugg = el('div', 'adk-tabpane', '<div class="adk-chips" data-adk-sugg-cats></div><div class="adk-grid adk-grid--sugg" data-adk-sugg><p class="abl-help">Loading ideas...</p></div>');
    sugg.setAttribute('data-adk-pane', 'sugg');
    var quick = el('div', 'adk-tabpane', '<p class="abl-help">Every line of text on this side of your sign. Change the words here; the sign updates as you type.</p><div class="adk-quick" data-adk-quick></div>');
    quick.setAttribute('data-adk-pane', 'quick'); quick.hidden = true; fontsWrap.hidden = true;
    body.appendChild(sugg); body.appendChild(fontsWrap); body.appendChild(quick);
    ui.textBody = body; ui.sugg = $('[data-adk-sugg]', sugg); ui.suggCats = $('[data-adk-sugg-cats]', sugg); ui.quick = $('[data-adk-quick]', quick);
    $$('[data-adk-preset]', top).forEach(function (b) { b.addEventListener('click', function () { addPreset(b.getAttribute('data-adk-preset')); }); });
    $$('[data-adk-tab]', top).forEach(function (b) {
      b.addEventListener('click', function () { textTab(b.getAttribute('data-adk-tab')); });
    });
    var textRail = document.querySelector('[data-abl-tool="text"]');
    if (textRail) textRail.addEventListener('click', function () { setTimeout(function () { if (st.textTab === 'sugg' || !st.textTab) renderSuggestions(); if (st.textTab === 'quick') renderQuick(); }, 0); });
    st.textTab = 'sugg';
  }
  function textTab(name) {
    st.textTab = name;
    $$('[data-adk-tab]', ui.textBody).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-adk-tab') === name ? 'true' : 'false'); });
    $$('[data-adk-pane]', ui.textBody).forEach(function (p) { p.hidden = p.getAttribute('data-adk-pane') !== name; });
    if (name === 'sugg') renderSuggestions();
    if (name === 'quick') renderQuick();
  }
  function addPreset(kind) {
    var fam = kind === 'h' ? 'Anton' : 'Jost';
    K.ready().then(function () { fabric = K.fabric(); canvas(); registerClasses(); hookCanvas(); return fontsReady([fam]); }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, b = bgObj(), dark = false;
      try { dark = b && window.ArdorBG ? window.ArdorBG.isDark(b.ablBg) : false; } catch (e) {}
      var H = Math.min(s.h * 0.30, s.w * 0.16);
      var spec = {
        h: { t: 'Add a heading', fs: H, y: s.y + s.h * 0.28, w: s.w * 0.92 },
        s: { t: 'Add a subheading', fs: H * 0.46, y: s.y + s.h * 0.56, w: s.w * 0.86 },
        b: { t: 'Add a little bit of body text', fs: H * 0.26, y: s.y + s.h * 0.78, w: s.w * 0.8 }
      }[kind];
      var t = K.look(new fabric.IText(kind === 'h' ? spec.t.toUpperCase() : spec.t, { fontFamily: fam, fontSize: spec.fs, fill: dark ? '#FFFFFF' : '#16161b', textAlign: 'center', originX: 'center', originY: 'center', left: z.Wi / 2, top: spec.y, paintFirst: 'stroke', strokeLineJoin: 'round', strokeWidth: 0, stroke: null, ablKind: 'text', ablStroke: 0, ablRole: kind === 'h' ? 'headline' : (kind === 's' ? 'sub' : 'detail'), charSpacing: kind === 'h' ? 20 : 0 }));
      if (kind !== 'h' && fam === 'Jost') t.set({ fontWeight: kind === 's' ? '600' : '400' });
      var w = t.getScaledWidth(); if (w > spec.w) t.scale(t.scaleX * spec.w / w);
      // don't land exactly on top of another text
      var tries = 0;
      while (tries++ < 4 && fc.getObjects().some(function (o) { return o !== t && o.ablKind === 'text' && Math.abs(o.top - t.top) < spec.fs * 0.6 && Math.abs(o.left - t.left) < z.Wi * 0.3; })) t.set({ top: clamp(t.top + spec.fs * 1.1, s.y + spec.fs / 2, s.y + s.h - spec.fs / 2) });
      K.fitInside(t, s);
      K.place(t);
      track('text_' + kind);
    }).catch(failed);
  }

  function isDarkFace() { var b = bgObj(); try { if (b && window.ArdorBG) return window.ArdorBG.isDark(b.ablBg); } catch (e) {} return false; }
  function renderSuggestions() {
    if (!ui.sugg) return;
    Promise.all([K.ready(), loadTpl(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.suggestionCategories ? T.suggestionCategories() : [];
      if (!ui.suggCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.suggCats.appendChild(all);
        cats.forEach(function (c) { var n = typeof c === 'string' ? c : (c.name || c.id); var id = typeof c === 'string' ? c : (c.id || c.name); var b = el('button', 'adk-chip', esc(n)); b.type = 'button'; b.setAttribute('data-c', id); ui.suggCats.appendChild(b); });
        ui.suggCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.suggCat = b.getAttribute('data-c'); renderSuggestions(); });
      }
      $$('[data-c]', ui.suggCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.suggCat ? 'true' : 'false'); });
      var items = T.listSuggestions(st.suggCat), dark = isDarkFace();
      return fontsReady(FONT_PRE).then(function () {
        ui.sugg.textContent = '';
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--sugg' + (dark ? ' is-dark' : '')); b.type = 'button'; b.title = it.name; b.setAttribute('aria-label', 'Add ' + it.name);
          b.addEventListener('click', function () { addSuggestion(it); });
          ui.sugg.appendChild(b);
          setTimeout(function () { try { b.appendChild(suggThumb(it, dark)); } catch (e) {} }, i * 12);
        });
      });
    }).catch(failed);
  }
  function suggThumb(it, dark) {
    var key = 's|' + it.id + '|' + dark;
    if (st.thumbs[key]) { var im0 = new Image(); im0.src = st.thumbs[key]; im0.alt = ''; return im0; }
    var bw = 50, bh = 22, px = 6;
    var objsT = window.ArdorTPL.buildSuggestion(fabric, it, { x: 1, y: 1, w: bw - 2, h: bh - 2 }, { dark: dark, info: tinfo() });
    var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: bw * px, height: bh * px, enableRetinaScaling: false, renderOnAddRemove: false });
    sc.setViewportTransform([px, 0, 0, px, 0, 0]);
    sc.backgroundColor = dark ? '#1d2230' : '#f4f2ec';
    objsT.forEach(function (o) { sc.add(o); });
    sc.renderAll();
    var url = sc.toDataURL({ format: 'png' });
    sc.dispose();
    st.thumbs[key] = url;
    var im = new Image(); im.src = url; im.alt = ''; return im;
  }
  function addSuggestion(it) {
    Promise.all([K.ready(), loadTpl()]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      K.targetFace();
      var z = cfgSize(), s = z.safe, others = fc.getObjects().filter(function (o) { return o.ablKind !== 'bg'; }).length;
      var bw = others ? s.w * 0.62 : s.w * 0.9, bh = others ? s.h * 0.5 : s.h * 0.8;
      if (s.w / s.h < 1) { bw = s.w * (others ? 0.8 : 0.92); bh = s.h * (others ? 0.38 : 0.6); }
      var box = { x: z.Wi / 2 - bw / 2, y: (s.y + s.h / 2) - bh / 2, w: bw, h: bh };
      var list = window.ArdorTPL.buildSuggestion(fabric, it, box, { dark: isDarkFace(), info: tinfo() });
      K.setQuiet(true);
      list.forEach(function (o) { K.look(o); o.ablTpl = null; fc.add(o); });
      K.setQuiet(false);
      if (list.length > 1) { var sel = new fabric.ActiveSelection(list, { canvas: fc }); K.look(sel); fc.setActiveObject(sel); }
      else if (list[0]) fc.setActiveObject(list[0]);
      K.changed(true); K.syncProps(); fc.requestRenderAll();
      if (phone()) K.closeDrawer();
      toast('Added. Drag to move it, or tap a line of text to change the words.', 4500);
      track('suggestion');
    }).catch(failed);
  }

  var qtT = 0;
  function qtRefreshSoon(skipFocused) { clearTimeout(qtT); qtT = setTimeout(function () { if (st.textTab === 'quick' && ui.quick && !ui.quick.closest('[hidden]')) renderQuick(skipFocused); }, 120); }
  function renderQuick(skipFocused) {
    if (!ui.quick) return;
    if (skipFocused && ui.quick.contains(document.activeElement)) return;
    var texts = objs().filter(function (o) { return o.ablKind === 'text' || o.type === 'i-text'; });
    ui.quick.textContent = '';
    if (!texts.length) { ui.quick.appendChild(el('p', 'abl-help', 'No text on this side yet. Add a heading, a suggestion or a template first.')); return; }
    texts.forEach(function (o, i) {
      var ta = el('textarea', 'abl-input abl-textarea adk-qt'); ta.rows = Math.min(3, String(o.text).split('\n').length); ta.value = o.text; ta.setAttribute('aria-label', 'Text line ' + (i + 1));
      ta.style.fontFamily = '\'' + o.fontFamily + '\', sans-serif';
      ta.addEventListener('focus', function () { try { fc.setActiveObject(o); fc.requestRenderAll(); K.syncProps(); } catch (e) {} });
      ta.addEventListener('input', function () { o.set('text', ta.value || ' '); if (o.ablStroke) o.set({ strokeWidth: o.fontSize * o.ablStroke * 0.012 }); o.setCoords(); fc.requestRenderAll(); if (o.ablTpl) st.tplDirty = true; try { API.renderArtOnly(); } catch (e) {} });
      ta.addEventListener('change', function () { K.changed(true); K.syncProps(); });
      ui.quick.appendChild(ta);
    });
  }

  // ---------- Templates ----------
  function buildTemplatesPanel() {
    var p = panel('templates', 'Templates',
      '<p class="abl-help">Pick a design and make it yours. Every word, color and shape can be changed, moved or deleted, and the layout fits the size you choose. Sign layouts show on the sign, rider layouts on the rider.</p>' +
      '<details class="adk-info" data-adk-info-box><summary>Fill in your details <small>(optional)</small></summary>' +
        '<label class="adk-field"><span>Agent name</span><input class="abl-input" data-adk-info="agent" maxlength="60" autocomplete="name"></label>' +
        '<label class="adk-field"><span>Brokerage</span><input class="abl-input" data-adk-info="brokerage" maxlength="60" autocomplete="organization"></label>' +
        '<label class="adk-field"><span>Phone</span><input class="abl-input" data-adk-info="phone" maxlength="30" inputmode="tel" autocomplete="tel"></label>' +
        '<label class="adk-field"><span>Website or listing link</span><input class="abl-input" data-adk-info="web" maxlength="80" inputmode="url" autocomplete="url"></label>' +
        '<p class="abl-help adk-small">Your details show on every template below. Templates with a QR spot turn your website into a QR code.</p>' +
        '<button type="button" class="adk-btn" data-adk-info-apply hidden>Update my sign with these details</button>' +
      '</details>' +
      '<div class="adk-chips" data-adk-tpl-cats></div>' +
      '<div class="adk-confirm" data-adk-confirm hidden><p>This replaces what is on this side of your sign (you can undo).</p><div><button type="button" class="adk-btn" data-adk-yes>Use this template</button><button type="button" class="adk-btn adk-btn--ghost" data-adk-no>Cancel</button></div></div>' +
      '<div class="adk-grid adk-grid--tpl" data-adk-tpl><p class="abl-help">Loading templates...</p></div>');
    ui.tplPanel = p; ui.tpl = $('[data-adk-tpl]', p); ui.tplCats = $('[data-adk-tpl-cats]', p); ui.confirm = $('[data-adk-confirm]', p);
    $$('[data-adk-info]', p).forEach(function (inp) {
      inp.addEventListener('input', function () {
        st.info[inp.getAttribute('data-adk-info')] = inp.value.replace(/^\s+/, '');
        lsSet(INFO_KEY, st.info);
        clearTimeout(st.infoT); st.infoT = setTimeout(function () { st.thumbs = {}; renderTemplates(); }, 500);
        var ab = $('[data-adk-info-apply]', p); if (ab) ab.hidden = !(st.tpl && st.tplFace === curFace());
      });
    });
    $('[data-adk-info-apply]', p).addEventListener('click', function () { if (st.tpl) applyTemplate(st.tpl, { keepEdits: true, reason: 'info' }); });
    $('[data-adk-no]', p).addEventListener('click', function () { ui.confirm.hidden = true; st.pending = null; });
    $('[data-adk-yes]', p).addEventListener('click', function () { ui.confirm.hidden = true; if (st.pending) applyTemplate(st.pending, {}); st.pending = null; });
  }
  function syncInfoFields() { if (!ui.tplPanel) return; $$('[data-adk-info]', ui.tplPanel).forEach(function (inp) { inp.value = st.info[inp.getAttribute('data-adk-info')] || ''; }); }
  function openTemplates() { renderTemplates(); }
  function renderTemplates() {
    if (!ui.tpl) return;
    Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var T = window.ArdorTPL, cats = T.categories ? T.categories() : (window.ArdorTPLData.categories || []);
      // real estate: only the categories that have templates for the piece being edited (sign or rider)
      var pc = pieceOf();
      cats = cats.filter(function (c) { return T.list(c.id || c.name).some(function (x) { return isRiderTpl(x) === (pc === 'rider'); }); });
      if (ui.tplCatsPiece !== pc) { ui.tplCatsPiece = pc; ui.tplCats.textContent = ''; st.tplCat = ''; }
      if (!ui.tplCats.children.length) {
        var all = el('button', 'adk-chip', 'All'); all.type = 'button'; all.setAttribute('data-c', ''); ui.tplCats.appendChild(all);
        cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c.name || c.id)); b.type = 'button'; b.setAttribute('data-c', c.id || c.name); ui.tplCats.appendChild(b); });
        if (!ui.tplCats.__adkOn) { ui.tplCats.__adkOn = true; ui.tplCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.tplCat = b.getAttribute('data-c'); renderTemplates(); }); }
      }
      $$('[data-c]', ui.tplCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.tplCat ? 'true' : 'false'); });
      return fontsReady(FONT_PRE.concat(['Arial'])).then(function () {
        var z = cfgSize(), key = z.Wi + 'x' + z.Hi + '|' + JSON.stringify(st.info);
        if (st.thumbKey !== key) { st.thumbs = {}; st.thumbKey = key; }
        var items = T.list(st.tplCat).filter(forPiece);
        ui.tpl.textContent = '';
        ui.tpl.classList.toggle('is-tall', z.Wi / z.Hi < 0.9);
        ui.tpl.classList.toggle('is-xwide', z.Wi / z.Hi >= 3.2);
        items.forEach(function (it, i) {
          var b = el('button', 'adk-card adk-card--tpl'); b.type = 'button'; b.setAttribute('aria-label', 'Use template: ' + it.name);
          b.innerHTML = '<span class="adk-card__img"></span><span class="adk-card__name">' + esc(it.name) + '</span>';
          b.addEventListener('click', function () { chooseTemplate(it); });
          ui.tpl.appendChild(b);
          lazyThumb(b, function () { $('.adk-card__img', b).appendChild(tplThumb(it, z)); }, i);
        });
      });
    }).catch(failed);
  }
  function qrPathFn(text) {
    try { var q = window.ArdorQR.encode(text, 'M'); var p = window.ArdorQR.path(q, { quiet: 0, style: 'square', finder: 'square' }); return { d: p.d, size: p.size }; } catch (e) { return null; }
  }
  // Oct 18 2026 (Claude): draw template thumbnails only when their card scrolls into view (inside the drawer list),
  // one per idle moment, instead of all of them back to back. On phones drawing every thumbnail at once froze scrolling.
  function lazyThumb(card, draw, i) {
    var run = function () { if (card.__adkThumb) return; card.__adkThumb = true; try { draw(); } catch (e) { try { console.warn(e); } catch (x) {} } };
    var idle = window.requestIdleCallback ? function (f) { window.requestIdleCallback(f, { timeout: 400 }); } : function (f) { setTimeout(f, 16); };
    if (!('IntersectionObserver' in window)) { setTimeout(run, 30 + i * 25); return; }
    var io = new IntersectionObserver(function (ents) {
      for (var k = 0; k < ents.length; k++) { if (ents[k].isIntersecting) { io.disconnect(); idle(run); return; } }
    }, { root: card.closest('.abl-drawer__body, .adk-body') || null, rootMargin: '400px 0px' });
    io.observe(card);
  }
  function tplThumb(it, z) {
    var key = 't|' + it.id;
    if (!st.thumbs[key]) {
      var maxW = 260, maxH = 170, px = Math.min(maxW / z.Wi, maxH / z.Hi);
      var cv = el('canvas'); var sc = new fabric.StaticCanvas(cv, { width: Math.round(z.Wi * px), height: Math.round(z.Hi * px), enableRetinaScaling: false, renderOnAddRemove: false });
      sc.setViewportTransform([px, 0, 0, px, 0, 0]);
      sc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: it.bg }));
      window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, tplSafe(z), { info: tinfo(), qrPath: qrPathFn }).forEach(function (o) { sc.add(o); });
      sc.renderAll();
      st.thumbs[key] = sc.toDataURL({ format: 'jpeg', quality: 0.85 });
      sc.dispose();
    }
    var im = new Image(); im.src = st.thumbs[key]; im.alt = ''; return im;
  }
  function designOnFace() { return objs().length > 0 || !!faceArt(); }
  function chooseTemplate(it) {
    if (designOnFace() && !(st.tpl && st.tplFace === curFace() && !st.tplDirty && !faceArt())) {
      st.pending = it; ui.confirm.hidden = false; ui.confirm.scrollIntoView({ block: 'nearest' });
      return;
    }
    applyTemplate(it, { carry: true }); // Oct 20 2026: a clean switch keeps what the customer added (see applyTemplate)
  }
  // Oct 20 2026: what a clean template switch carries over: the customer's own layers, uploaded logo / photo and QR code
  // (not the old template's wording, colors or background)
  function carryOf(old, id) { var c = editsByRole(old, id); c.map = {}; c.bg = null; c.dirty = false; return c; }
  // build the template for the current size; keepEdits: keep wording and colors the customer changed (by role and order)
  function applyTemplate(it, opt) {
    opt = opt || {};
    return Promise.all([K.ready(), loadTpl(), load('bg'), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      return fontsReady(window.ArdorTPL.fonts(it));
    }).then(function () {
      if (opt.face && curFace() !== opt.face) return; // a re-fit for a face that is no longer shown
      var face = K.targetFace();
      var z = cfgSize();
      var old = fc.getObjects().slice();
      // Oct 20 2026: a clean switch (no confirm: the old template was untouched) carried nothing before, so the customer's
      // own layers, uploaded logo / photo and QR code were deleted without a word
      var onFace = faceTpl(face, old); // Oct 20 2026 (refix follow-up): after Undo, st.tpl can still name the template that was undone
      var keep = opt.keepEdits ? editsByRole(old, it.id) : (opt.carry && st.tpl && st.tplFace === face ? carryOf(old, onFace ? onFace.id : st.tpl.id) : null);
      var carried = opt.carry && keep ? keep.extra.length + Object.keys(keep.img).length + (keep.qr ? 1 : 0) : 0;
      var list = window.ArdorTPL.build(fabric, it, z.Wi, z.Hi, tplSafe(z), { info: tinfo(), qrPath: qrPathFn });
      var moved = 0;
      if (keep) { restoreEdits(list, keep); list = reuseImages(list, keep); var cc = clearCarried(list, keep.extra, tplSafe(z), it.id, !!opt.carry); list = cc.list; moved = cc.moved; } // Oct 20 2026 (refix): carried logos / photos clear of the words
      st.rebuilding = true;
      K.setQuiet(true);
      fc.discardActiveObject();
      if (old.length) fc.remove.apply(fc, old);
      var bgSpec = (keep && keep.bg) || it.bg;
      var fitKey0 = areaKey(z.Wi, z.Hi, tplSafe(z, face));
      fc.add(new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: fitSpec(bgSpec, it.id, fitKey0) }));
      st.fitMem = st.fitMem || {}; st.fitMem[face] = { id: it.id, fit: fitKey0 };
      list.forEach(function (o) { K.look(o); fc.add(o); });
      // real estate: a re-fit (new size or new details) keeps what the customer added (text, clipart, images, artwork)
      if (keep) (keep.extra || []).forEach(function (o) { if (o.ablKind === 'cover') fc.insertAt(o, 1); else fc.add(o); });
      K.setQuiet(false);
      st.rebuilding = false;
      // Oct 20 2026: the artwork is parked (artGuard), so undo of this template brings it back
      if (faceArt(face) && !opt.keepEdits) { park[face] = { art: faceArt(face), sig: sigOf(old) }; lastSig[face] = park[face].sig; try { API.setArt(face, null); } catch (e) {} }
      st.tpl = it; st.tplFace = face; st.tplVar = window.ArdorTPL.layoutKey ? window.ArdorTPL.layoutKey(it, z.Wi, z.Hi) : window.ArdorTPL.variant(z.Wi, z.Hi); st.tplDirty = !!(keep && keep.dirty);
      K.changed(true); K.sync(); K.syncProps(); fc.requestRenderAll();
      var ab = $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = false;
      if (phone()) K.closeDrawer();
      if (opt.reason === 'size') toast('We re-arranged your template for the new size.', 5000);
      else if (opt.reason !== 'info' && opt.reason !== 'link') toast('Template added.' + (carried ? ' What you added yourself stays on it.' : '') + (moved ? ' We moved your logo or photo so it does not cover any words.' : '') + ' Tap any text to change the words, or drag things around.', moved ? 7000 : 5000);
      track(opt.reason === 'size' ? 'template_refit' : 'template');
      qtRefreshSoon();
    }).catch(function (e) { st.rebuilding = false; try { K.setQuiet(false); } catch (x) {} failed(e); });
  }
  function roleKey(o, counts) { var r = (o.ablRole || 'x') + ':' + (o.ablKind || o.type); counts[r] = (counts[r] || 0) + 1; return r + ':' + counts[r]; }
  function editsByRole(old, id) {
    var out = { map: {}, bg: null, dirty: st.tplDirty, img: {}, qr: null, extra: [] }, counts = {};
    old.forEach(function (o) {
      if (o.ablKind === 'bg') { out.bg = o.ablBg; return; }
      if ((o.ablRole === 'photo-img' || o.ablRole === 'logo-img') && o.ablKind === 'image' && o.ablTpl === id) { if (out.img[o.ablRole.slice(0, -4)]) { o.ablTpl = null; out.extra.push(o); } else out.img[o.ablRole.slice(0, -4)] = o; return; } // Oct 20 2026 (relogo): a second copy (Duplicate) stays as the customer's own layer
      if (o.ablKind === 'qr' && !out.qr) { out.qr = o; return; }
      if (o.ablTpl !== id) { out.extra.push(o); return; }
      if (o.ablTpl !== id) return;
      var k = roleKey(o, counts);
      out.map[k] = { text: o.ablKind === 'text' ? o.text : null, fill: o.fill, stroke: o.stroke, ablStroke: o.ablStroke, font: o.fontFamily, built: o.__adkText };
    });
    return out;
  }
  function restoreEdits(list, keep) {
    var counts = {};
    list.forEach(function (o) {
      var k = roleKey(o, counts), e = keep.map[k]; if (!e) return;
      if (o.ablKind === 'text') {
        var boxW = o.getScaledWidth();
        // after undo / redo the remembered build wording is gone: compare with what the template builds now instead
        var nw = function (x) { return String(x).replace(/\s+/g, ' ').replace(/^ | $/g, ''); };
        var changedByUser = e.text != null && (e.built != null ? e.text !== e.built : nw(e.text) !== nw(o.text));
        if (changedByUser) o.set('text', e.text);
        if (e.font && e.font !== o.fontFamily) o.set('fontFamily', e.font);
        o.set({ fill: e.fill });
        if (e.ablStroke != null) { o.set({ ablStroke: e.ablStroke, stroke: e.ablStroke ? e.stroke : null, strokeWidth: e.ablStroke ? o.fontSize * e.ablStroke * 0.012 : 0 }); }
        if (typeof o.initDimensions === 'function') o.initDimensions();
        var w = o.getScaledWidth(); if (w > boxW * 1.02 && boxW > 0) o.scale(o.scaleX * boxW / w);
      } else if (e.fill && typeof e.fill === 'string' && o.ablRole !== 'qr') { o.set({ fill: e.fill }); }
    });
  }
  // real estate: the box of a template spot (photo or logo): its shapes, else all of its parts
  function spotBox(list, role) {
    var box = null, shapes = list.filter(function (o) { return o.ablRole === role && o.ablKind !== 'text'; });
    (shapes.length ? shapes : list.filter(function (o) { return o.ablRole === role; })).forEach(function (o) {
      var r = o.getBoundingRect(true, true);
      if (!box) box = { l: r.left, t: r.top, r: r.left + r.width, b: r.top + r.height };
      else { box.l = Math.min(box.l, r.left); box.t = Math.min(box.t, r.top); box.r = Math.max(box.r, r.left + r.width); box.b = Math.max(box.b, r.top + r.height); }
    });
    return box;
  }
  function fitToBox(im, box) {
    var bw = box.r - box.l, bh = box.b - box.t, w = im.width || 1, h = im.height || 1, s = Math.min(bw / w, bh / h);
    im.set({ originX: 'center', originY: 'center', left: box.l + bw / 2, top: box.t + bh / 2, scaleX: s, scaleY: s, angle: 0 });
    im.setCoords();
  }
  // Oct 20 2026 (relogo): fit an image inside another object's own (unrotated) box: same centre, angle, flips, opacity
  function fitToObj(im, t) {
    var bw = t.getScaledWidth(), bh = t.getScaledHeight(), w = im.width || 1, h = im.height || 1, s = Math.min(bw / w, bh / h), c = t.getCenterPoint();
    im.set({ originX: 'center', originY: 'center', left: c.x, top: c.y, scaleX: s, scaleY: s, angle: t.angle || 0, flipX: !!t.flipX, flipY: !!t.flipY, opacity: t.opacity == null ? 1 : t.opacity });
    im.setCoords();
  }
  // a re-arranged template (new size): an uploaded agent photo or logo moves into the new layout's spot
  function reuseImages(list, keep) {
    ['photo', 'logo'].forEach(function (role) {
      var im = keep.img && keep.img[role]; if (!im) return;
      var box = spotBox(list, role); if (!box) { im.ablTpl = null; keep.extra.push(im); return; } // Oct 20 2026: no spot in the new layout: keep it where it is
      var at = -1;
      list = list.filter(function (o, i) { if (o.ablRole === role) { if (at < 0) at = i; return false; } return true; });
      fitToBox(im, box);
      var nt = list.filter(function (o) { return !!o.ablTpl; })[0]; if (nt) im.ablTpl = nt.ablTpl; // belongs to the new layout now
      list.splice(Math.max(0, at), 0, im);
    });
    if (keep.qr) {
      var q = keep.qr, qb = spotBox(list, 'qr');
      if (qb) {
        var qa = -1;
        list = list.filter(function (o, i) { if (o.ablRole === 'qr') { if (qa < 0) qa = i; return false; } return true; });
        var k = Math.min(qb.r - qb.l, qb.b - qb.t) / Math.max(0.01, q.width || 1);
        q.set({ scaleX: k, scaleY: k, angle: 0, left: (qb.l + qb.r) / 2, top: (qb.t + qb.b) / 2 }); q.setCoords();
        list.splice(Math.max(0, qa), 0, q);
      } else keep.extra.push(q);
    }
    return list;
  }
  // ---------- Oct 20 2026 (refix): carried-over logos and photos never cover the template's words ----------
  // A template switch (or a re-arrange for a new size, product or details) left an uploaded logo or agent photo that is
  // not in a spot of the new layout where it was, so it could land on the phone line, the agent name or other words.
  // Now a template switch puts the first carried logo / photo into the new template's empty logo / photo spot, and any
  // carried logo or photo that still covers words, a QR code or a spot moves to the nearest free place in the layout
  // area, clear of words, spots, QR codes and other images (made smaller only when it has to be). Things that cover
  // nothing stay exactly where they are.
  function rectOf(o) { var r = o.getBoundingRect(true, true); return { l: r.left, t: r.top, r: r.left + r.width, b: r.top + r.height }; }
  function overlapOf(a, b) { var w = Math.min(a.r, b.r) - Math.max(a.l, b.l), h = Math.min(a.b, b.b) - Math.max(a.t, b.t); return w > 0 && h > 0 ? { w: w, h: h } : null; }
  function isCarriedImg(o) { return o.ablKind === 'image' && (o.ablRole === 'logo-img' || o.ablRole === 'photo-img'); }
  function isWords(o) { return o.ablKind === 'text' || o.ablKind === 'qr' || o.ablRole === 'qr' || o.ablRole === 'logo' || o.ablRole === 'photo'; }
  // the biggest size (up to the current one, at least a quarter of it or 1.5 in) and the place nearest to the current
  // centre where box b clears every block by 0.15 in; when nothing is clear, the smallest size where it covers least
  function freePlace(b, blocks, area) {
    var w0 = b.r - b.l, h0 = b.b - b.t, cx = (b.l + b.r) / 2, cy = (b.t + b.b) / 2, pad = 0.15;
    if (!(w0 > 0) || !(h0 > 0) || !(area.w > 2 * pad) || !(area.h > 2 * pad)) return null;
    var step = Math.max(0.1, Math.min(area.w, area.h) / 60), top = Math.min(1, (area.w - 2 * pad) / w0, (area.h - 2 * pad) / h0);
    var low = Math.min(top, Math.max(0.25, 1.5 / Math.min(w0, h0))), fs = [], f, n, i, j, k, best = null;
    for (f = top; f > low + 1e-6; f *= 0.9) fs.push(f);
    fs.push(low);
    for (n = 0; n < fs.length; n++) {
      var w = w0 * fs[n], h = h0 * fs[n], nx = Math.floor((area.w - 2 * pad - w) / step + 1e-6), ny = Math.floor((area.h - 2 * pad - h) / step + 1e-6), last = n === fs.length - 1;
      for (i = 0; i <= nx; i++) {
        for (j = 0; j <= ny; j++) {
          var x = area.x + pad + w / 2 + i * step, y = area.y + pad + h / 2 + j * step, c = { l: x - w / 2 - pad, t: y - h / 2 - pad, r: x + w / 2 + pad, b: y + h / 2 + pad };
          var d = (x - cx) * (x - cx) + (y - cy) * (y - cy), cover = 0;
          for (k = 0; k < blocks.length; k++) { var ov = overlapOf(c, blocks[k]); if (ov) { if (!last) break; cover += ov.w * ov.h; } }
          if (!last && k < blocks.length) continue;
          if (!best || cover < best.cover - 1e-9 || (Math.abs(cover - best.cover) < 1e-9 && d < best.d)) best = { f: fs[n], x: x, y: y, d: d, cover: cover };
        }
      }
      if (best) return best;
    }
    return best;
  }
  function clearCarried(list, extra, area, tplId, toSpot) {
    var ups = extra.filter(isCarriedImg), moved = 0;
    if (!ups.length || !area) return { list: list, moved: 0 };
    if (toSpot) ['logo', 'photo'].forEach(function (role) {
      var im = ups.filter(function (o) { return o.ablRole === role + '-img'; })[0], box = im ? spotBox(list, role) : null, at = -1;
      if (!box) return;
      list = list.filter(function (o, i) { if (o.ablRole === role) { if (at < 0) at = i; return false; } return true; });
      fitToBox(im, box); im.ablTpl = tplId; // into the new template's empty spot, like a logo / photo that was in the old spot
      list.splice(Math.max(0, at), 0, im);
      extra.splice(extra.indexOf(im), 1); ups.splice(ups.indexOf(im), 1);
    });
    var all = list.concat(extra), words = all.filter(isWords).map(rectOf), imgs = all.filter(function (o) { return o.ablKind === 'image'; });
    ups.forEach(function (im) {
      var b = rectOf(im);
      if (!words.some(function (k) { var ov = overlapOf(b, k); return !!(ov && ov.w > 0.1 && ov.h > 0.1); })) return;
      var p = freePlace(b, words.concat(imgs.filter(function (o) { return o !== im; }).map(rectOf)), area);
      if (!p) return;
      im.set({ scaleX: im.scaleX * p.f, scaleY: im.scaleY * p.f });
      im.setPositionByOrigin(new fabric.Point(p.x, p.y), 'center', 'center');
      im.setCoords();
      moved++;
    });
    return { list: list, moved: moved };
  }
  // ---------- real estate: keep every face's template fitted to its page (Oct 19 2026, QA) ----------
  // A size, product or rider change re-arranges each face that holds a template right away, also the faces that are
  // not on screen (their layers live in the layers file, kit.objectsFor(face)), keeping the customer's wording, colors,
  // photo, logo, QR code and own layers. Runs on the 450 ms watch, after every designer redraw and on every click
  // (capture phase, so before 3D, proof, PDF, print and Add to cart read the faces). No undo step of its own: undo
  // brings back the last customer step and that is re-arranged again for the page it is on now.
  var fitting = false;
  function fontsOk(list) {
    try { if (!document.fonts || !document.fonts.check) return true; return list.every(function (f) { return document.fonts.check('20px "' + f + '"'); }); } catch (e) { return true; }
  }
  function faceTpl(face, objsF) {
    var bg = null, ids = {};
    objsF.forEach(function (o) { if (o.ablKind === 'bg') { if (!bg) bg = o; } else if (o.ablTpl) ids[o.ablTpl] = 1; });
    var m = bg && bg.ablBg && bg.ablBg.fit ? { id: bg.ablBg.tpl, fit: bg.ablBg.fit } : (st.fitMem && st.fitMem[face]);
    return m && m.id && ids[m.id] ? m : null;
  }
  function fitAll() {
    if (!booted || !K || !API || fitting || st.rebuilding || !window.ArdorTPL || !window.ArdorTPLData) return;
    if (!canvas() || !settled()) return;
    try { if (!fabric) fabric = K.fabric(); } catch (e) { return; }
    if (!fabric || !fabric.ArdorBg) return;
    var faces = []; try { faces = K.faces ? K.faces() : (API.faces ? API.faces() : ['front']); } catch (e) { return; }
    var cf = curFace(), todo = [];
    (faces || []).forEach(function (f) {
      var pg = pageOfFace(f); if (!pg) return;
      var list = f === cf ? fc.getObjects() : (K.objectsFor(f) || []);
      var t = faceTpl(f, list); if (!t) return;
      var area = tplSafe({ Wi: pg.Wi, Hi: pg.Hi, safe: safeFor(f, pg) }, f);
      if (t.fit === areaKey(pg.Wi, pg.Hi, area)) return;
      var it = window.ArdorTPL.get(t.id); if (!it) return;
      var want = areaKey(pg.Wi, pg.Hi, area), last = st.fitLast && st.fitLast[f];
      if (last && last.key === want && Date.now() - last.t < 3000) return; // never loop on one face
      todo.push({ f: f, it: it, pg: pg, area: area });
    });
    if (!todo.length) return;
    var fl = [];
    todo.forEach(function (x) { window.ArdorTPL.fonts(x.it).forEach(function (n) { if (fl.indexOf(n) < 0) fl.push(n); }); });
    if (!fontsOk(fl)) { fontsReady(fl).then(function () { setTimeout(fitAll, 0); }).catch(function () {}); return; }
    fitting = true;
    try {
      // let the layers file move each piece's layers to its new page first (it keeps them where they were, scaled)
      try { K.sync(); } catch (e) {}
      st.fitLast = st.fitLast || {};
      todo.forEach(function (x) { st.fitLast[x.f] = { key: areaKey(x.pg.Wi, x.pg.Hi, x.area), t: Date.now() }; rebuildFace(x.f, x.it, x.pg, x.area); });
      K.changed(false);
      var cpg = pageOfFace(curFace());
      if (cpg) fc.getObjects().forEach(function (o) { o.ablBase = { W: cpg.Wi, H: cpg.Hi, l: o.left, t: o.top, sx: o.scaleX, sy: o.scaleY }; });
      fc.requestRenderAll();
    } catch (e) { try { console.warn('[ardor kit] re-arrange', e); } catch (x) {} }
    st.rebuilding = false; try { K.setQuiet(false); } catch (e) {}
    fitting = false;
  }
  function rebuildFace(face, it, pg, area) {
    var isCur = face === curFace();
    var store = isCur ? null : K.objectsFor(face);
    if (!isCur && !store) return;
    var old = isCur ? fc.getObjects().slice() : store.slice();
    var keep = editsByRole(old, it.id);
    var list = window.ArdorTPL.build(fabric, it, pg.Wi, pg.Hi, area, { info: tinfo(), qrPath: qrPathFn });
    restoreEdits(list, keep); list = reuseImages(list, keep);
    list = clearCarried(list, keep.extra, area, it.id, false).list; // Oct 20 2026 (refix): carried logos / photos clear of the words
    var key = areaKey(pg.Wi, pg.Hi, area);
    var out = [new fabric.ArdorBg({ left: 0, top: 0, width: pg.Wi, height: pg.Hi, ablBg: fitSpec(keep.bg || it.bg, it.id, key) })];
    list.forEach(function (o) { K.look(o); out.push(o); });
    keep.extra.forEach(function (o) { if (o.ablKind === 'cover') out.splice(1, 0, o); else out.push(o); });
    // every layer remembers this page as its base, so a later move of this piece's layers starts from here
    out.forEach(function (o) { o.setCoords(); o.ablBase = { W: pg.Wi, H: pg.Hi, l: o.left, t: o.top, sx: o.scaleX, sy: o.scaleY }; });
    st.fitMem = st.fitMem || {}; st.fitMem[face] = { id: it.id, fit: key };
    st.byFace[face] = { tpl: it, v: window.ArdorTPL.layoutKey ? window.ArdorTPL.layoutKey(it, pg.Wi, pg.Hi) : '', dirty: !!keep.dirty };
    if (isCur) {
      st.rebuilding = true; K.setQuiet(true);
      fc.discardActiveObject();
      if (old.length) fc.remove.apply(fc, old);
      out.forEach(function (o) { fc.add(o); });
      K.setQuiet(false); st.rebuilding = false;
      st.tpl = it; st.tplFace = face; st.tplVar = st.byFace[face].v; st.tplDirty = !!keep.dirty;
      toast('We re-arranged your ' + (/^rider/.test(face) ? 'rider' : 'sign') + ' for the new size.', 5000);
    } else {
      store.splice.apply(store, [0, store.length].concat(out));
      st.offFit = st.offFit || {}; st.offFit[face] = true;
      if (st.tplFace === face) { st.tpl = it; st.tplVar = st.byFace[face].v; }
    }
    track('template_refit');
  }

  // remember the wording each template text was built with (to tell customer edits from tokens)
  function markBuilt(list) { list.forEach(function (o) { if (o.ablKind === 'text') o.__adkText = o.text; }); }

  // banner size changed: re-arrange the template when the layout shape changes (wide, extra wide, square, tall)
  // real estate: each face (sign front / back, rider front / back) remembers its own template; when the size of the
  // piece being edited changes, its template is re-arranged for the new layout shape (wide, extra wide, square, tall)
  var lastSize = '', lastFace = '';
  function watchSize() {
    if (!booted || !K || !API || !uiReady) return;
    var b; try { b = K.banner(); } catch (e) { return; }
    if (!b || !(b.Wi > 0) || !(b.Hi > 0)) return;
    if (!settled()) return;
    var f = curFace() || 'front', pc = pieceOf();
    if (f !== lastFace) {
      if (st.tpl && st.tplFace) st.byFace[st.tplFace] = { tpl: st.tpl, v: st.tplVar, dirty: st.tplDirty };
      var m = st.byFace[f];
      st.tpl = m ? m.tpl : null; st.tplFace = m ? f : null; st.tplVar = m ? m.v : ''; st.tplDirty = m ? m.dirty : false;
      var ab = ui.tplPanel && $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = !st.tpl;
      if (lastFace && ui.tplPanel && !ui.tplPanel.hidden) { st.thumbs = {}; renderTemplates(); }
      lastFace = f;
      if (st.offFit && st.offFit[f]) { delete st.offFit[f]; toast('We re-arranged your ' + (/^rider/.test(f) ? 'rider' : 'sign') + ' for the new size.', 5000); }
    }
    var key = pc + ':' + b.Wi + 'x' + b.Hi;
    if (key === lastSize) return;
    var first = !lastSize; lastSize = key;
    if (first) return;
    st.thumbs = {};
    if (ui.tplPanel && !ui.tplPanel.hidden) renderTemplates();
  }
  function watchTick() { watchSize(); fitAll(); try { artGuard(); } catch (e) {} try { if (fc) fc.getObjects().forEach(ringClicks); } catch (e) {} } // Oct 20 2026 (refix): ringClicks

  // ---------- Background ----------
  function buildBgPanel() {
    var p = panel('background', 'Background',
      '<p class="abl-help" data-adk-bg-note>Pick a color, gradient, pattern, texture or scene for the whole sign.</p>' +
      '<div class="adk-chips" data-adk-bg-cats></div>' +
      '<div class="adk-bg-custom"><label class="abl-color"><input type="color" value="#ffffff" aria-label="Pick any background color" data-adk-bg-color><span>Any color</span></label><button type="button" class="adk-btn adk-btn--ghost" data-adk-bg-none>No background</button></div>' +
      '<div class="adk-grid adk-grid--bg" data-adk-bg><p class="abl-help">Loading...</p></div>');
    ui.bgPanel = p; ui.bgGrid = $('[data-adk-bg]', p); ui.bgCats = $('[data-adk-bg-cats]', p); ui.bgNote = $('[data-adk-bg-note]', p);
    $('[data-adk-bg-color]', p).addEventListener('input', function (e) { setBackground({ t: 'solid', c: e.target.value }, true); });
    $('[data-adk-bg-color]', p).addEventListener('change', function (e) { var from = st.liveFrom; st.liveFrom = null; autoContrast({ t: 'solid', c: e.target.value }, from); K.changed(true); });
    $('[data-adk-bg-none]', p).addEventListener('click', function () { removeBackground(); });
  }
  function openBackground() {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var G = window.ArdorBG;
      if (!ui.bgCats.children.length) {
        G.cats.forEach(function (c) { var b = el('button', 'adk-chip', esc(c)); b.type = 'button'; b.setAttribute('data-c', c); ui.bgCats.appendChild(b); });
        ui.bgCats.addEventListener('click', function (e) { var b = e.target.closest('[data-c]'); if (!b) return; st.bgCat = b.getAttribute('data-c'); renderBg(); });
      }
      renderBg();
    }).catch(failed);
  }
  function renderBg() {
    var G = window.ArdorBG, art = faceArt();
    $$('[data-c]', ui.bgCats).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === st.bgCat ? 'true' : 'false'); });
    ui.bgNote.innerHTML = art ? '<b>Your uploaded artwork covers the sign.</b> Colors here fill any space around your artwork. To use a gradient, pattern, texture or scene, remove your artwork first (Artwork panel).' : 'Pick a color, gradient, pattern, texture or scene for the whole sign. Your text and clipart stay on top.';
    ui.bgGrid.textContent = '';
    var z = cfgSize(), ar = clamp(z.Wi / z.Hi, 0.5, 3);
    G.gallery.filter(function (g) { return g.cat === st.bgCat; }).forEach(function (g) {
      var b = el('button', 'adk-card adk-card--bg'); b.type = 'button'; b.title = g.name; b.setAttribute('aria-label', 'Background: ' + g.name);
      var dis = art && g.spec.t !== 'solid'; if (dis) b.disabled = true;
      var w = 120, h = Math.round(w / ar);
      try { var t = G.thumb(g.spec, w, h); t.className = 'adk-bg-thumb'; b.appendChild(t); } catch (e) {}
      b.appendChild(el('span', 'adk-card__name', esc(g.name)));
      b.addEventListener('click', function () { setBackground(g.spec, false); });
      ui.bgGrid.appendChild(b);
    });
  }
  function setBackground(spec, live) {
    Promise.all([K.ready(), load('bg')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var face = K.targetFace(), art = faceArt(face);
      if (art) { // behind uploaded artwork only a plain color is possible
        if (spec.t !== 'solid') { toast('Remove your uploaded artwork first to use this background.', 5000); return; }
        art.bg = spec.c; try { API.renderArtOnly(); } catch (e) {}
        var inp = document.querySelector('[data-abb-bg]'); if (inp) inp.value = spec.c;
        return;
      }
      var z = cfgSize(), b = bgObj(), prev = b ? b.ablBg : null;
      if (b) { b.ablBg = keepFit(spec, b.ablBg); b.set({ dirty: true }); fc.requestRenderAll(); if (!live) K.changed(true); else { try { API.renderArtOnly(); } catch (e) {} } }
      else {
        st.rebuilding = true; K.setQuiet(true);
        b = new fabric.ArdorBg({ left: 0, top: 0, width: z.Wi, height: z.Hi, ablBg: spec });
        fc.add(b); fc.moveTo(b, 0);
        K.setQuiet(false); st.rebuilding = false;
        K.changed(!live);
      }
      if (!live) autoContrast(spec, prev); else if (!st.liveFrom) st.liveFrom = prev || { t: 'solid', c: '#FFFFFF' };
      if (!live && st.liveFrom) { st.liveFrom = null; }
      K.sync(); fc.requestRenderAll();
      if (!live) track('background');
    }).catch(failed);
  }
  // after a background change, flip plain black or white text that would disappear (only text sitting right on the background)
  function lum(hex) { var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim()); if (!m) return 0.5; var n = parseInt(m[1], 16); return (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255; }
  function overShape(t, list) {
    var i = list.indexOf(t), c = t.getCenterPoint();
    for (var j = i - 1; j >= 0; j--) { var o = list[j]; if (o.ablKind === 'bg') continue; var r = o.getBoundingRect(true, true); if (c.x >= r.left && c.x <= r.left + r.width && c.y >= r.top && c.y <= r.top + r.height) return true; }
    return false;
  }
  function autoContrast(spec, prevSpec) {
    var G = window.ArdorBG; if (!G) return;
    var dark = false, was = false; try { dark = G.isDark(spec); was = prevSpec ? G.isDark(prevSpec) : false; } catch (e) { return; }
    if (dark === was) return;
    var list = objs(), changedAny = false;
    list.forEach(function (o) {
      if (o.ablKind !== 'text' || typeof o.fill !== 'string' || overShape(o, list)) return;
      var L = lum(o.fill);
      if (dark && L < 0.22) { o.set('fill', '#FFFFFF'); changedAny = true; }
      if (!dark && L > 0.85) { o.set('fill', '#16161B'); changedAny = true; }
    });
    if (changedAny) fc.requestRenderAll();
  }
  function removeBackground() {
    var art = faceArt();
    if (art) { art.bg = '#FFFFFF'; try { API.renderArtOnly(); } catch (e) {} return; }
    var b = bgObj(); if (!b) return;
    fc.remove(b); K.changed(true); fc.requestRenderAll();
  }

  // ---------- QR code ----------
  var QR_TYPES = [
    ['url', 'Website', [['url', 'Website address', 'url', 'yourwebsite.com']]],
    ['tel', 'Phone call', [['tel', 'Phone number', 'tel', '(555) 555-5555']]],
    ['sms', 'Text message', [['sms', 'Phone number', 'tel', '(555) 555-5555'], ['body', 'Message (optional)', 'text', '']]],
    ['email', 'Email', [['to', 'Email address', 'email', 'you@yourbusiness.com'], ['subject', 'Subject (optional)', 'text', '']]],
    ['wifi', 'Wi-Fi', [['ssid', 'Network name', 'text', ''], ['pass', 'Password', 'text', ''], ['enc', 'Security', 'select:WPA=WPA / WPA2,WEP=WEP,nopass=No password', 'WPA']]],
    ['vcard', 'Contact card', [['name', 'Name', 'text', ''], ['org', 'Business', 'text', ''], ['phone', 'Phone', 'tel', ''], ['email', 'Email', 'email', ''], ['url', 'Website', 'url', '']]],
    ['text', 'Plain text', [['text', 'Text', 'textarea', '']]]
  ];
  function buildQrPanel() {
    var opts = QR_TYPES.map(function (t) { return '<option value="' + t[0] + '">' + t[1] + '</option>'; }).join('');
    var p = panel('qr', 'QR code',
      '<p class="abl-help">Make a QR code people can scan from your sign. It prints sharp at any size.</p>' +
      '<label class="adk-field"><span>What should it open?</span><select class="abl-input" data-adk-qr-type>' + opts + '</select></label>' +
      '<div data-adk-qr-fields></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Style</span><select class="abl-input" data-adk-qr-style><option value="square">Square</option><option value="rounded">Rounded</option></select></label>' +
      '<label class="adk-field"><span>Corners</span><select class="abl-input" data-adk-qr-finder><option value="square">Square</option><option value="rounded">Rounded</option></select></label></div>' +
      '<div class="adk-two"><label class="adk-field"><span>Code color</span><span class="abl-color"><input type="color" value="#000000" data-adk-qr-fg aria-label="QR code color"></span></label>' +
      '<label class="adk-field"><span>Behind the code</span><span class="abl-color"><input type="color" value="#ffffff" data-adk-qr-bg aria-label="QR code background color"></span></label></div>' +
      '<p class="adk-warn" data-adk-qr-warn hidden></p>' +
      '<div class="adk-qr-preview" data-adk-qr-preview></div>' +
      '<button type="button" class="adk-btn adk-btn--wide" data-adk-qr-add>Add QR code to my sign</button>' +
      '<p class="abl-help adk-small" data-adk-qr-size></p>' +
      '<p class="abl-help adk-small">Tip: test it with your phone camera on the proof before you order. Make the code about 1 in wide for every 10 in of scanning distance (about 12 in wide for people 10 ft away).</p>');
    ui.qrPanel = p; ui.qrType = $('[data-adk-qr-type]', p); ui.qrFields = $('[data-adk-qr-fields]', p);
    ui.qrPrev = $('[data-adk-qr-preview]', p); ui.qrWarn = $('[data-adk-qr-warn]', p); ui.qrAdd = $('[data-adk-qr-add]', p); ui.qrSize = $('[data-adk-qr-size]', p);
    ui.qrType.addEventListener('change', function () { qrFields(); qrPreview(); });
    ['[data-adk-qr-style]', '[data-adk-qr-finder]', '[data-adk-qr-fg]', '[data-adk-qr-bg]'].forEach(function (s) { $(s, p).addEventListener('input', qrPreview); });
    ui.qrAdd.addEventListener('click', addQr);
    qrFields();
  }
  function qrFields(vals) {
    var t = QR_TYPES.filter(function (x) { return x[0] === ui.qrType.value; })[0];
    vals = vals || {};
    ui.qrFields.textContent = '';
    t[2].forEach(function (f) {
      var lab = el('label', 'adk-field', '<span>' + esc(f[1]) + '</span>'), inp;
      if (f[2] === 'textarea') { inp = el('textarea', 'abl-input abl-textarea'); inp.rows = 3; }
      else if (f[2].indexOf('select:') === 0) {
        inp = el('select', 'abl-input');
        f[2].slice(7).split(',').forEach(function (o) { var kv = o.split('='), op = el('option'); op.value = kv[0]; op.textContent = kv[1]; inp.appendChild(op); });
      } else { inp = el('input', 'abl-input'); inp.type = f[2] === 'url' ? 'text' : f[2]; if (f[2] === 'url') inp.setAttribute('inputmode', 'url'); }
      inp.setAttribute('data-adk-qf', f[0]);
      if (f[3] && inp.tagName !== 'SELECT') inp.placeholder = f[3];
      var v = vals[f[0]] != null ? vals[f[0]] : (f[0] === 'url' && ui.qrType.value === 'url' ? st.info.web : (f[0] === 'tel' ? st.info.phone : (ui.qrType.value === 'vcard' ? ({ name: st.info.agent, org: st.info.brokerage, phone: st.info.phone, url: st.info.web })[f[0]] || '' : '')));
      if (inp.tagName === 'SELECT') inp.value = vals[f[0]] || f[3]; else inp.value = v || '';
      inp.addEventListener('input', qrPreview);
      lab.appendChild(inp); ui.qrFields.appendChild(lab);
    });
  }
  function qrValues() { var v = {}; $$('[data-adk-qf]', ui.qrFields).forEach(function (i) { v[i.getAttribute('data-adk-qf')] = i.value.replace(/^\s+|\s+$/g, ''); }); return v; }
  function qrPayload(type, v) {
    var P = window.ArdorQR.payload;
    if (type === 'url') return v.url ? P.url(v.url) : '';
    if (type === 'tel') return v.tel ? P.tel(v.tel.replace(/[^\d+]/g, '')) : '';
    if (type === 'sms') return v.sms ? P.sms(v.sms.replace(/[^\d+]/g, ''), v.body || '') : '';
    if (type === 'email') return v.to ? P.email(v.to, v.subject || '', '') : '';
    if (type === 'wifi') return v.ssid ? P.wifi(v.ssid, v.pass || '', v.enc || 'WPA', false) : '';
    if (type === 'vcard') return (v.name || v.org) ? P.vcard({ name: v.name, org: v.org, phone: v.phone, email: v.email, url: v.url }) : '';
    return v.text ? P.text(v.text) : '';
  }
  function qrSettings() {
    var p = ui.qrPanel;
    return { type: ui.qrType.value, v: qrValues(), style: $('[data-adk-qr-style]', p).value, finder: $('[data-adk-qr-finder]', p).value, fg: $('[data-adk-qr-fg]', p).value, bg: $('[data-adk-qr-bg]', p).value };
  }
  function openQr() {
    load('qr').then(function () {
      var a = fc && fc.getActiveObject();
      if (a && a.ablKind === 'qr' && a.ablQr) { loadQrSettings(a); }
      else { st.qrEdit = null; ui.qrAdd.textContent = 'Add QR code to my sign'; }
      qrPreview();
    }).catch(failed);
  }
  function loadQrSettings(o) {
    var s = null; try { s = typeof o.ablQr === 'string' ? JSON.parse(o.ablQr) : o.ablQr; } catch (e) {}
    if (!s || !s.type) return;
    st.qrEdit = o;
    ui.qrType.value = s.type; qrFields(s.v || {});
    $('[data-adk-qr-style]', ui.qrPanel).value = s.style || 'square';
    $('[data-adk-qr-finder]', ui.qrPanel).value = s.finder || 'square';
    $('[data-adk-qr-fg]', ui.qrPanel).value = s.fg || '#000000';
    $('[data-adk-qr-bg]', ui.qrPanel).value = s.bg || '#ffffff';
    ui.qrAdd.textContent = 'Update this QR code';
  }
  function qrPreview() {
    if (!window.ArdorQR || !ui.qrPrev) return;
    var s = qrSettings(), data = qrPayload(s.type, s.v), Q = window.ArdorQR;
    ui.qrWarn.hidden = true;
    if (!data) { ui.qrPrev.innerHTML = '<p class="abl-help">Fill in the details above to see your code.</p>'; ui.qrAdd.disabled = true; return; }
    try {
      var q = Q.encode(data, 'M');
      ui.qrPrev.innerHTML = Q.svg(q, { fg: s.fg, bg: s.bg, px: 180, quiet: 4, style: s.style, finder: s.finder });
      ui.qrAdd.disabled = false;
      if (!Q.ok(s.fg, s.bg)) { ui.qrWarn.textContent = 'Phones scan best with a dark code on a light background. These colors may not scan.'; ui.qrWarn.hidden = false; }
    } catch (e) { ui.qrPrev.innerHTML = '<p class="adk-warn">That is too long for a QR code. Please shorten it.</p>'; ui.qrAdd.disabled = true; }
    qrSizeNote();
  }
  function qrSizeNote() {
    var o = st.qrEdit || (fc && fc.getActiveObject());
    if (!ui.qrSize || !window.ArdorQR) return;
    if (o && o.ablKind === 'qr') { var w = o.getScaledWidth(); ui.qrSize.textContent = 'On your sign this code is ' + (Math.round(w * 10) / 10) + ' in wide: easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft away.'; }
    else ui.qrSize.textContent = '';
  }
  function makeQrGroup(s, data, sizeIn) {
    var Q = window.ArdorQR, q = Q.encode(data, 'M');
    var p = Q.path(q, { quiet: 0, style: s.style, finder: s.finder });
    var code = new fabric.Path(p.d, { fill: s.fg, fillRule: 'evenodd', stroke: null, strokeWidth: 0, originX: 'center', originY: 'center' });
    var u = (sizeIn * 0.84) / Math.max(code.width || 1, code.height || 1);
    code.set({ scaleX: u, scaleY: u, left: 0, top: 0 });
    var r = sizeIn * 0.06;
    var plate = new fabric.Rect({ width: sizeIn, height: sizeIn, rx: r, ry: r, fill: s.bg, originX: 'center', originY: 'center', left: 0, top: 0, strokeWidth: 0 });
    var g = new fabric.Group([plate, code], { originX: 'center', originY: 'center', ablKind: 'qr', ablLabel: 'QR code', ablRole: 'qr', ablQr: JSON.stringify(s), lockScalingFlip: true });
    return g;
  }
  function addQr() {
    Promise.all([K.ready(), load('qr')]).then(function () {
      fabric = K.fabric(); canvas(); registerClasses(); hookCanvas();
      var s = qrSettings(), data = qrPayload(s.type, s.v);
      if (!data) return;
      K.targetFace();
      var z = cfgSize(), sz = Math.min(z.safe.h * 0.46, z.safe.w * 0.26, 30);
      var old = st.qrEdit && fc.getObjects().indexOf(st.qrEdit) >= 0 ? st.qrEdit : null;
      if (old) sz = old.getScaledWidth();
      // real estate: a template's QR spot gets the code in its place and at its size
      var spot = null;
      if (!old) { var phs = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; }); spot = phs.length ? spotBox(phs, 'qr') : null; if (spot) sz = Math.max(1, Math.min(spot.r - spot.l, spot.b - spot.t)); }
      var g = makeQrGroup(s, data, sz);
      K.look(g);
      if (old) {
        g.set({ left: old.left, top: old.top, angle: old.angle || 0 });
        var idx = fc.getObjects().indexOf(old);
        K.setQuiet(true); fc.remove(old); fc.insertAt(g, idx); K.setQuiet(false);
        fc.setActiveObject(g); g.setCoords(); K.changed(true); K.syncProps();
      } else {
        g.set({ left: z.safe.x + z.safe.w - sz / 2 - z.safe.w * 0.04, top: z.safe.y + z.safe.h / 2 });
        if (z.safe.w / z.safe.h < 1) g.set({ left: z.Wi / 2, top: z.safe.y + z.safe.h - sz / 2 - z.safe.h * 0.04 });
        if (spot) g.set({ left: (spot.l + spot.r) / 2, top: (spot.t + spot.b) / 2 });
        K.place(g);
      }
      st.qrEdit = g; ui.qrAdd.textContent = 'Update this QR code';
      qrSizeNote();
      // a template's QR spot placeholder is no longer needed
      var ph = fc.getObjects().filter(function (o) { return o.ablRole === 'qr' && o.ablKind !== 'qr'; });
      if (ph.length && !old) { K.setQuiet(true); fc.remove.apply(fc, ph); K.setQuiet(false); K.changed(true); }
      track('qr_' + s.type);
    }).catch(failed);
  }

  // ---------- properties panel extras (QR code, logo spot) ----------
  function buildPropsExtras() {
    var props = K.ui().props; if (!props) return;
    var qrBox = el('div', 'adk-props-qr', '<p class="abl-help" data-adk-pqr-size></p><button type="button" class="abl-done" data-adk-pqr-edit>Edit QR code</button>');
    qrBox.setAttribute('data-abl-p', 'qr'); qrBox.hidden = true;
    var logoBox = el('div', 'adk-props-logo', '<p class="abl-help" data-adk-logo-note>This is a spot for your brokerage logo.</p><label class="adk-btn adk-btn--wide adk-file"><span data-adk-logo-lbl>Upload logo</span><input type="file" accept="image/png,image/jpeg,image/webp,image/svg+xml" data-adk-logo-file hidden></label>');
    logoBox.hidden = true;
    var photoBox = el('div', 'adk-props-logo adk-props-photo', '<p class="abl-help" data-adk-photo-note>This is a spot for the agent photo. We crop your photo to fill it.</p><label class="adk-btn adk-btn--wide adk-file"><span data-adk-photo-lbl>Upload photo</span><input type="file" accept="image/png,image/jpeg,image/webp" data-adk-photo-file hidden></label>');
    photoBox.hidden = true;
    var head = $('.abl-props__head', props);
    if (head && head.nextSibling) { props.insertBefore(logoBox, head.nextSibling); props.insertBefore(photoBox, logoBox.nextSibling); } else { props.appendChild(logoBox); props.appendChild(photoBox); }
    props.appendChild(qrBox);
    ui.pQr = qrBox; ui.pLogo = logoBox; ui.pPhoto = photoBox;
    $('[data-adk-pqr-edit]', qrBox).addEventListener('click', function () { if (ui.tQr) ui.tQr.click(); });
    var tt = K.ui().pTitle;
    if (tt && window.MutationObserver) new MutationObserver(function () {
      var o = fc && fc.getActiveObject(); if (!o) return;
      var want = o.ablKind === 'qr' ? 'QR code' : (o.ablRole === 'logo' ? 'Logo spot' : (o.ablRole === 'photo' ? 'Agent photo spot' : (o.ablRole === 'photo-img' ? 'Agent photo' : (o.ablRole === 'logo-img' ? 'Your logo' : ''))));
      if (want && tt.textContent !== want) tt.textContent = want;
    }).observe(tt, { childList: true, characterData: true, subtree: true });
    $('[data-adk-logo-file]', logoBox).addEventListener('change', function (e) { var f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) addLogo(f, fc && fc.getActiveObject()); });
    $('[data-adk-photo-file]', photoBox).addEventListener('change', function (e) { var f = e.target.files && e.target.files[0]; e.target.value = ''; if (f) addPhoto(f, fc && fc.getActiveObject()); });
  }
  function selSync() {
    var o = fc && fc.getActiveObject(), u = K.ui();
    var isLogo = !!(o && (o.ablRole === 'logo' || o.ablRole === 'logo-img')), isPhoto = !!(o && (o.ablRole === 'photo' || o.ablRole === 'photo-img'));
    if (ui.pLogo) { ui.pLogo.hidden = !isLogo; $('[data-adk-logo-lbl]', ui.pLogo).textContent = o && o.ablRole === 'logo-img' ? 'Replace logo' : 'Upload logo'; $('[data-adk-logo-note]', ui.pLogo).textContent = o && o.ablRole === 'logo-img' ? 'Your brokerage logo.' : 'This is a spot for your brokerage logo.'; }
    if (ui.pPhoto) { ui.pPhoto.hidden = !isPhoto; $('[data-adk-photo-lbl]', ui.pPhoto).textContent = o && o.ablRole === 'photo-img' ? 'Replace photo' : 'Upload photo'; $('[data-adk-photo-note]', ui.pPhoto).textContent = o && o.ablRole === 'photo-img' ? 'The agent photo. A new photo is cropped to the same spot.' : 'This is a spot for the agent photo. We crop your photo to fill it.'; }
    if (o && o.ablKind === 'qr' && u && u.pTitle) {
      u.pTitle.textContent = 'QR code';
      var w = o.getScaledWidth(), sz = $('[data-adk-pqr-size]', ui.pQr);
      if (sz && window.ArdorQR) sz.textContent = Math.round(w * 10) / 10 + ' in wide. Easy to scan from about ' + Math.round(window.ArdorQR.scanDistanceFt(w)) + ' ft.';
      if (ui.qrPanel && !ui.qrPanel.hidden) { loadQrSettings(o); qrPreview(); }
    }
    if (o && o.ablRole === 'logo' && u && u.pTitle) u.pTitle.textContent = 'Logo spot';
    if (o && o.ablRole === 'photo' && u && u.pTitle) u.pTitle.textContent = 'Agent photo spot';
    if (o && o.ablRole === 'photo-img' && u && u.pTitle) u.pTitle.textContent = 'Agent photo';
    if (o && o.ablRole === 'logo-img' && u && u.pTitle) u.pTitle.textContent = 'Your logo';
  }
  // put an uploaded image into the template spots of a role ('logo' or 'photo'): replaces the spot (and an image put
  // there before), keeps its place in the stacking order (frames drawn over the spot stay on top), keeps the template id
  // Oct 20 2026 (relogo): target = the object selected when Upload / Replace was clicked. Replacing an uploaded image
  // (role-img) swaps only that image, in its own box, angle and layer; filling a template spot removes only the spot's
  // own parts, so other uploaded logos or photos on the face are never removed or merged into one box
  function putInSpot(im, role, fallback, target) {
    var all = fc.getObjects(), own = !!(target && target.ablRole === role + '-img' && all.indexOf(target) >= 0);
    var spots = own ? [target] : all.filter(function (o) { return o.ablRole === role; });
    var box = own ? null : spotBox(spots, role), z = cfgSize(), at = -1, tplId = null;
    spots.forEach(function (o) { var i = all.indexOf(o); if (at < 0 || i < at) at = i; if (o.ablTpl) tplId = o.ablTpl; });
    if (own) fitToObj(im, target);
    else { if (!box) box = fallback(z); fitToBox(im, box); }
    im.set({ ablKind: 'image', ablRole: role + '-img', ablTpl: tplId });
    K.look(im);
    K.setQuiet(true);
    if (spots.length) fc.remove.apply(fc, spots);
    if (at >= 0) fc.insertAt(im, Math.min(at, fc.getObjects().length)); else fc.add(im);
    K.setQuiet(false);
    fc.setActiveObject(im); im.setCoords();
    K.changed(true); K.syncProps(); fc.requestRenderAll();
    if (phone()) K.closeDrawer();
    return box;
  }
  function readImage(file, types, msg, cb) {
    if (!types.test(file.type) || file.size > 25 * 1024 * 1024) { toast(msg, 5000); return; }
    var rd = new FileReader();
    rd.onload = function () {
      var img = new Image();
      img.onload = function () { K.ready().then(function () { fabric = K.fabric(); canvas(); K.targetFace(); cb(img); }).catch(failed); };
      img.onerror = function () { toast('We could not read that image. Please try a PNG or JPG.', 5000); };
      img.src = rd.result;
    };
    rd.readAsDataURL(file);
  }
  function addLogo(file, target) {
    readImage(file, /^image\//, 'Please pick a PNG, JPG, WebP or SVG image under 25 MB.', function (img) {
      var max = 2400, w = img.naturalWidth || 800, h = img.naturalHeight || 800, k = Math.min(1, max / Math.max(w, h));
      var cv = el('canvas'); cv.width = Math.max(1, Math.round(w * k)); cv.height = Math.max(1, Math.round(h * k));
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      var url = cv.toDataURL(/png|svg|webp/.test(file.type) ? 'image/png' : 'image/jpeg', 0.92);
      fabric.Image.fromURL(url, function (im) {
        im.set({ ablLabel: 'Your logo' });
        putInSpot(im, 'logo', function (z) { return { l: z.Wi / 2 - z.safe.w * 0.15, t: z.Hi / 2 - z.safe.h * 0.2, r: z.Wi / 2 + z.safe.w * 0.15, b: z.Hi / 2 + z.safe.h * 0.2 }; }, target);
        track('logo');
      });
    });
  }
  // agent photo: cropped to cover the spot's box (center crop), round spots cut to a circle (transparent corners)
  function addPhoto(file, target) {
    readImage(file, /^image\/(png|jpeg|jpg|webp)$/i, 'Please pick a JPG, PNG or WebP photo under 25 MB.', function (img) {
      var own = !!(target && target.ablRole === 'photo-img' && fc.getObjects().indexOf(target) >= 0); // Oct 20 2026 (relogo): Replace photo = the selected photo only
      var spots = own ? [target] : fc.getObjects().filter(function (o) { return o.ablRole === 'photo'; });
      var z = cfgSize(), box = own ? { l: 0, t: 0, r: target.getScaledWidth(), b: target.getScaledHeight() } : spotBox(spots, 'photo');
      if (!box) { var d = Math.min(z.safe.w, z.safe.h) * 0.4; box = { l: z.safe.x + z.safe.w * 0.06, t: z.safe.y + (z.safe.h - d) / 2, r: z.safe.x + z.safe.w * 0.06 + d, b: z.safe.y + (z.safe.h + d) / 2 }; }
      var round = spots.some(function (o) { return /round/i.test(o.ablLabel || ''); });
      var bw = box.r - box.l, bh = box.b - box.t, ar = bw / bh;
      var sw = img.naturalWidth || 800, sh = img.naturalHeight || 800, cw = sw, ch = sh;
      if (sw / sh > ar) cw = sh * ar; else ch = sw / ar;
      var outW = Math.max(64, Math.round(Math.min(1800, cw, Math.max(bw, bh) * 150)));
      var outH = Math.max(64, Math.round(outW / ar));
      var cv = el('canvas'); cv.width = outW; cv.height = outH;
      var c2 = cv.getContext('2d');
      if (round) { c2.beginPath(); c2.ellipse(outW / 2, outH / 2, outW / 2, outH / 2, 0, 0, Math.PI * 2); c2.closePath(); c2.clip(); }
      c2.imageSmoothingQuality = 'high';
      c2.drawImage(img, (sw - cw) / 2, (sh - ch) / 2, cw, ch, 0, 0, outW, outH);
      var url = round ? cv.toDataURL('image/png') : cv.toDataURL('image/jpeg', 0.92);
      fabric.Image.fromURL(url, function (im) {
        im.set({ ablLabel: round ? 'Agent photo (round)' : 'Agent photo' });
        putInSpot(im, 'photo', function () { return box; }, target);
        track('photo');
      });
    });
  }

  // wrap ArdorTPL.build so every built text remembers its original wording
  function wrapBuild() {
    var T = window.ArdorTPL; if (!T || T.__adkWrapped) return;
    var b = T.build; T.build = function () { var r = b.apply(T, arguments); markBuilt(r); return r; }; T.__adkWrapped = true;
  }
  var _lt = loadTpl; loadTpl = function () { return _lt().then(function (x) { wrapBuild(); return x; }); };

  // before Add to cart: warn once when sample words or empty logo / QR spots are still on the banner
  var SAMPLE = /YOUR BUSINESS|\(555\) 555-5555|YOURWEBSITE\.COM|YOUR TAGLINE HERE|MONTH DAY|YOUR ADDRESS, CITY|YOUR LOGO|YOUR QR CODE|TEAM NAME|GRADUATE NAME|ADD A HEADING|ADD A SUBHEADING|ADD A LITTLE BIT OF BODY TEXT|YOUR NAME|AGENT NAME|YOUR BROKERAGE|BROKERAGE NAME|AGENT PHOTO|123 MAIN ST|\$000,000|0,000 SQ FT|YOUR CITY|LISTING ADDRESS/i;
  function leftovers() {
    if (!K || !fc) return [];
    var out = [];
    FACES.forEach(function (f) {
      var list = []; try { list = K.objectsFor(f) || []; } catch (e) { list = []; }
      list.forEach(function (o) {
        if (o.ablKind === 'text' && SAMPLE.test(String(o.text || '').replace(/\s+/g, ' '))) out.push(String(o.text).replace(/\s+/g, ' ').slice(0, 40));
        else if (o.ablRole === 'logo' && o.ablKind !== 'text' && out.indexOf('YOUR LOGO') < 0) out.push('YOUR LOGO');
        else if (o.ablRole === 'photo' && o.ablKind !== 'text' && out.indexOf('AGENT PHOTO') < 0) out.push('AGENT PHOTO');
      });
    });
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
  // ---------- Oct 20 2026 (upload bug): artwork uploaded onto a face that holds a template or a background ----------
  // The designer paints uploaded artwork UNDER the layers, so the full-page background layer of a template (or of a
  // Background pick) hid a new upload completely: on screen, in 3D, on the proof and in the print file. The designer's
  // loadFile (assets/ardor-realestate-builder.js) now asks first (askUpload): "Add it as a logo" = an ordinary image
  // layer on top (in the template's empty logo spot when it has one, else in the middle of the safe area), or
  // "Replace" = clearDesign takes the template's own layers (background, text, shapes, empty spots) off that face and
  // the file becomes its artwork; what the customer added (own text and clipart, uploaded logo / photo, QR codes) stays.
  // artGuard (450 ms watch) never lets artwork and a background layer share a face (undo after a replace): the
  // artwork is parked with a message and comes back when redo brings back the layers it was on.
  var upAsk = null, park = {}, lastSig = {};
  function layersOf(face) { try { return canvas() && face === curFace() ? fc.getObjects() : (K.objectsFor(face) || []); } catch (e) { return []; } }
  function keepOnReplace(o) { return o.ablRole === 'logo-img' || o.ablRole === 'photo-img' || o.ablKind === 'qr'; }
  function designFor(face) {
    if (!booted || !K || !API) return null;
    var list = layersOf(face), bg = false, tpl = 0, spot = false;
    list.forEach(function (o) {
      if (o.ablKind === 'bg') bg = true;
      else if (o.ablTpl && !keepOnReplace(o)) tpl++;
      if (o.ablRole === 'logo') spot = true;
    });
    if (!bg && !tpl) return null;
    return { bg: bg, tpl: tpl > 0, spot: spot, piece: /^rider/.test(face) ? 'rider' : 'sign' };
  }
  function sigOf(list) { return list.map(function (o) { return [o.type, o.ablKind || '', o.ablRole || '', Math.round((o.left || 0) * 1000), Math.round((o.top || 0) * 1000)].join(':'); }).join('|'); }
  // take the template (or background) off a face; why: 'ask' (the customer picked Replace) or 'ai' (an AI design)
  function clearDesign(face, why) {
    var d = designFor(face); if (!d) return false;
    var isCur = !!canvas() && face === curFace(), list = layersOf(face).slice(), gone = [], kept = 0;
    list.forEach(function (o) {
      if (o.ablKind === 'bg' || (o.ablTpl && !keepOnReplace(o))) { gone.push(o); return; }
      if (o.ablTpl) o.ablTpl = null; // no template left to re-arrange it into
      kept++;
    });
    if (isCur) { K.setQuiet(true); fc.discardActiveObject(); if (gone.length) fc.remove.apply(fc, gone); K.setQuiet(false); }
    else { var store = K.objectsFor(face) || []; gone.forEach(function (o) { var i = store.indexOf(o); if (i >= 0) store.splice(i, 1); }); }
    if (st.fitMem) delete st.fitMem[face];
    delete st.byFace[face];
    if (st.tplFace === face) { st.tpl = null; st.tplFace = null; st.tplVar = ''; st.tplDirty = false; var ab = ui.tplPanel && $('[data-adk-info-apply]', ui.tplPanel); if (ab) ab.hidden = true; }
    delete park[face]; lastSig[face] = sigOf(layersOf(face));
    K.changed(true); if (isCur) { K.sync(); K.syncProps(); fc.requestRenderAll(); }
    var what = d.tpl ? 'template' : 'background';
    toast(why === 'ai' ? 'Your new design replaced the ' + what + ' on your ' + d.piece + '.' : 'We took the ' + what + ' off your ' + d.piece + '. Your artwork fills it now.' + (kept ? ' What you added yourself stays on top.' : '') + ' Undo brings the ' + what + ' back.', 6000);
    return true;
  }
  function closeAsk() { if (!upAsk) return; try { upAsk.parentNode.removeChild(upAsk); } catch (e) {} document.removeEventListener('keydown', askKey, true); upAsk = null; }
  function askKey(e) { if (e.key === 'Escape' && upAsk) { e.preventDefault(); e.stopPropagation(); closeAsk(); } }
  // o: { file, face, preview() (the designer's PDF / AI / EPS / TIFF / PSD preview), replace() }
  function askUpload(o) {
    var d = designFor(o.face);
    if (!d) { o.replace(); return; }
    closeAsk(); delete park[o.face];
    var what = d.tpl ? 'template' : 'background', p = d.piece, w = el('div', 'adk-ask');
    w.innerHTML = '<div class="adk-ask__card" role="dialog" aria-modal="true" aria-labelledby="adk-ask-t">' +
      '<p class="adk-ask__t" id="adk-ask-t">Your ' + p + ' has a ' + what + '</p>' +
      '<p class="adk-ask__p">How do you want to use <b>' + esc(o.file.name) + '</b>?</p>' +
      '<button type="button" class="adk-ask__opt" data-adk-ask="logo"><b>Add it as a logo on my ' + p + '</b><span>' +
      (d.spot ? 'It goes in the template\'s logo spot.' : 'It goes in the middle of your ' + p + '.') + ' Drag or resize it any time.</span></button>' +
      '<button type="button" class="adk-ask__opt" data-adk-ask="replace"><b>Replace the ' + what + ' with my artwork</b><span>Your file fills the whole ' + p + '. ' +
      (d.tpl ? 'The template\'s background, text and shapes come off.' : 'The background comes off.') + ' What you added yourself stays.</span></button>' +
      '<button type="button" class="adk-ask__x" data-adk-ask="cancel">Cancel</button></div>';
    w.addEventListener('click', function (e) {
      var bt = e.target.closest ? e.target.closest('[data-adk-ask]') : null;
      if (!bt) { if (e.target === w) closeAsk(); return; }
      var c = bt.getAttribute('data-adk-ask'); closeAsk();
      if (c === 'logo') uploadAsLogo(o, p);
      else if (c === 'replace') o.replace();
    });
    document.body.appendChild(w); upAsk = w;
    document.addEventListener('keydown', askKey, true);
    var first = w.querySelector('[data-adk-ask="logo"]'); if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
  }
  // the uploaded file as an ordinary image layer: into the empty logo spot of the template, else fitted into the
  // middle half of the safe area; PDF / AI / EPS / TIFF / PSD files use the designer's preview picture
  function uploadAsLogo(o, p) {
    var f = o.file, isSvg = /svg/i.test(f.type) || /\.svg$/i.test(f.name), isJpg = /jpe?g/i.test(f.type) || /\.jpe?g$/i.test(f.name);
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(f.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(f.name);
    var got = isImg ? new Promise(function (res, rej) {
      var rd = new FileReader();
      rd.onload = function () { var img = new Image(); img.onload = function () { res(img); }; img.onerror = rej; img.src = rd.result; };
      rd.onerror = rej; rd.readAsDataURL(f);
    }) : Promise.resolve(o.preview ? o.preview() : null).then(function (r) { if (r && r.ok && r.canvas) return r.canvas; throw new Error('preview'); });
    got.then(function (img) { return K.ready().then(function () { return img; }); }).then(function (img) {
      fabric = K.fabric(); canvas(); K.targetFace();
      var max = 2400, w = img.naturalWidth || img.width || 800, h = img.naturalHeight || img.height || 800;
      var s = isSvg ? max / Math.max(w, h) : Math.min(1, max / Math.max(w, h));
      var cv = el('canvas'); cv.width = Math.max(1, Math.round(w * s)); cv.height = Math.max(1, Math.round(h * s));
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      var url = cv.toDataURL(isJpg ? 'image/jpeg' : 'image/png', 0.92);
      fabric.Image.fromURL(url, function (im) {
        if (!im || !im.width) { toast('We could not read that image. Please try a PNG or JPG.', 5000); return; }
        im.set({ ablLabel: 'Your logo' });
        if (fc.getObjects().some(function (x) { return x.ablRole === 'logo'; })) {
          putInSpot(im, 'logo', function (z) { return { l: z.Wi / 2 - z.safe.w * 0.15, t: z.Hi / 2 - z.safe.h * 0.2, r: z.Wi / 2 + z.safe.w * 0.15, b: z.Hi / 2 + z.safe.h * 0.2 }; });
          toast('Your logo is in the template\'s logo spot. Drag or resize it any time.', 5000);
        } else {
          var z = cfgSize(), sa = z.safe;
          fitToBox(im, { l: sa.x + sa.w * 0.25, t: sa.y + sa.h * 0.25, r: sa.x + sa.w * 0.75, b: sa.y + sa.h * 0.75 });
          im.set({ ablKind: 'image', ablRole: 'logo-img', ablTpl: null });
          K.look(im); K.place(im); fc.requestRenderAll();
          toast('Your logo is on your ' + (p || 'sign') + '. Drag or resize it any time.', 5000);
        }
        track('logo');
      });
    }).catch(function () {
      toast(isImg ? 'We could not read that image. Please try a PNG or JPG.' : 'We could not show this file as a logo. Use a PNG, JPG or SVG, or pick Replace to use it as your whole design.', 7000);
    });
  }
  function artGuard() {
    if (!booted || !K || !API || st.rebuilding || upAsk || !canvas() || !settled()) return;
    var faces = []; try { faces = K.faces ? K.faces() : []; } catch (e) { return; }
    (faces || []).forEach(function (f) {
      var a = faceArt(f), list = layersOf(f), bg = list.some(function (o) { return o.ablKind === 'bg'; }), p = /^rider/.test(f) ? 'rider' : 'sign';
      if (a && !bg) { lastSig[f] = sigOf(list); return; }
      if (a && bg) {
        var known = typeof lastSig[f] === 'string';
        park[f] = { art: a, sig: known ? lastSig[f] : null };
        try { API.setArt(f, null); } catch (e) {}
        var wh = list.some(function (o) { return !!o.ablTpl; }) ? 'template' : 'background';
        toast(known ? 'Your ' + p + ' shows the ' + wh + ' again, so your uploaded artwork is off it for now. Undo or redo back to your artwork to bring it back.' : 'Your uploaded artwork was under the ' + wh + ', so we took it off the ' + p + '. Upload it again to add it.', 7000);
        return;
      }
      if (!a && !bg && park[f] && park[f].sig !== null && sigOf(list) === park[f].sig) {
        var x = park[f]; delete park[f];
        try { API.setArt(f, x.art); } catch (e) {}
        toast('Your artwork is back on the ' + p + '.', 4000);
      }
    });
  }
  var cartOk = 0;
  document.addEventListener('click', function (e) {
    try { fitAll(); } catch (x) {} // every click: faces are fitted before 3D, proof, PDF, print or Add to cart read them
    var b = e.target.closest && e.target.closest('[data-abb-add], [data-abb-add-d], [data-abb-add-m]');
    if (!b || Date.now() - cartOk < 60000) return;
    var left = leftovers();
    if (!left.length) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    toast('Your sign still shows sample text: ' + left.slice(0, 4).join(', ') + (left.length > 4 ? '...' : '') + '. Change or delete it before you order.', 12000, { label: 'Order anyway', run: function () { cartOk = Date.now(); b.click(); } });
    track('sample_text_warning');
  }, true);

  window.ArdorRealestateKit = { v: 1, applyTemplate: function (id) { return loadTpl().then(function () { return applyTemplate(window.ArdorTPL.get(id), {}); }); }, setBackground: setBackground, state: st, designFor: designFor, askUpload: askUpload, clearDesign: clearDesign };
  if (window.ArdorRealestateLayers && window.ArdorRealestateLayers.kit) boot();
  else document.addEventListener('ardor:layers-kit', boot);
  var tries = 0, t = setInterval(function () { if (booted || ++tries > 80) { clearInterval(t); return; } boot(); }, 250);
})();
